<template>
  <div class="columns is-mobile">
    <div class="column dashboard__menu">
      <div class="sidebar sidebar--static">
        <div class="inner">
          <ul class="sidebar-menu">
            <li v-for="sidebarMenu in sidebar" :key="sidebarMenu.title" :title="sidebarMenu.title">
              <router-link :to="sidebarMenu.url" class="polycom-link">
                <img
                  :src="require(`@/assets/images/icons/${sidebarMenu.icon}`)"
                  :alt="sidebarMenu.title"
                  class="sidebar-menu__img"
                />
                <span class="is-block polycom-link-text">{{sidebarMenu.title}}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="column content-management content-management-conference">
      <div class="breadcrumb-wrapper">
        <img src="@/assets/images/icons/icon-home.png" alt class="icon-home" />
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link to="/index">Trang chủ</router-link>
            </li>
            <li>
              <router-link to="/ongoing-conference-list">Các cuộc họp đang diễn ra</router-link>
            </li>
            <li class="is-active">
              <a>{{jointParticipants&&jointParticipants.length&&jointParticipants[0].displayName}}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="content-wrapper">
        <div class="field is-grouped field-search-party">
          <div class="control custom-control">
            <b-field
              label="Lọc username của participant"
              custom-class="has-text-weight-normal content-management-conference__label"
              horizontal
            >
              <b-input type="text" icon="search" @input="updateKeyword" />
            </b-field>
          </div>

          <!--<div class="conference__addText">
            <div><b style="padding-right: 10px;">Cài đặt giờ: {{ isTimer ? 'Có' : 'Không' }}</b>

              <span v-if="isTimer">
                <button @click="removeTimerText">Huỷ đặt giờ</button>
              </span>
              <span v-else>
                <b-select placeholder="Chọn thời gian" v-model="timeSelected">
                  <option
                      v-for="option in timeList"
                      :value="option"
                      :key="option">
                      {{ option}}
                  </option>
                </b-select>
                <button @click="setTimerText">Đặt giờ</button>
              </span>
            </div>
          </div>-->
        </div>
      </div>
      <b-collapse :aria-id="conferenceId" animation="slide" class="collapse-party" :open="true">
        <div
          slot="trigger"
          slot-scope="props"
          class="conference-heading"
          role="button"
          :aria-controls="conferenceId"
        >
          <span class="conference-arrow">
            <b-icon :icon="`${props.open? 'chevron-circle-down':'chevron-circle-right'}`" />
          </span>
          {{jointParticipants&&jointParticipants.length&&jointParticipants[0].displayName}}
        </div>
        <div class="conference-content">
          <div style="display: flex; padding: 10px 0;">
            <div
              v-if="filteredParticipants && filteredParticipants.length"
              class="conference__endpoint-count has-text-weight-bold"
            >Số điểm cầu đang tham gia cuộc họp: {{filteredParticipants.length}}</div>
            <div
              v-if="shareContentParty"
              class="conference__endpoint-count has-text-weight-bold"
            >Người chia sẻ nội dung: {{shareContentParty&&shareContentParty.name}}</div>

            <div>
              <download-excel
                :fetch="fetchDataToExport"
                :fields="json_fields"
                :title="totalReport"
                type="xls"
              >
                <span
                  style="text-decoration: underline; color: blue; cursor: pointer;"
                >Export thông tin cuộc họp</span>
              </download-excel>
            </div>
            <div
              style="padding: 0 25px;"
              class="has-text-weight-bold"
            >Mật khẩu cuộc họp: {{filteredParticipants&&filteredParticipants.length&&filteredParticipants[0].confPass}}</div>
          </div>
          <div class="conference-content__wrapper">
            <table class="table is-fullwidth">
              <tr class="table-header" style="font-weight: bold;">
                <td class="conference-checkbox-column">
                  <span class="conference-table-text">Lựa chọn</span>
                  <b-checkbox
                    v-model="selectedAllMediaParticipantIDs"
                    class="conference-table-select-all"
                  ></b-checkbox>
                </td>
                <td @click="sortByColumn('index')" class="conference-order-column sortable">
                  <span class="conference-table-text">
                    STT.
                    <b-icon
                      icon="arrow-up"
                      size="is-small"
                      class="sort-icon"
                      :class="sortableValue"
                      v-if="sortPartySetting&&sortPartySetting.type==='index'"
                    />
                  </span>
                </td>
                <td @click="sortByColumn('name')" class="sortable column__username">
                  <span class="conference-table-text">
                    Tên điểm cầu
                    <b-icon
                      icon="arrow-up"
                      size="is-small"
                      class="sort-icon"
                      :class="sortableValue"
                      v-if="sortPartySetting&&sortPartySetting.type==='name'"
                    />
                  </span>
                </td>
                <td>
                  <span class="conference-table-text">Đổi tên</span>
                </td>
                <td @click="sortByColumn('connectionStatus')" class="sortable" style="width: 100px">
                  <span class="conference-table-text">Kết nối <b-icon
                      icon="arrow-up"
                      size="is-small"
                      class="sort-icon"
                      :class="sortableValue"
                      v-if="sortPartySetting&&sortPartySetting.type==='connectionStatus'"
                    /></span>
                </td>
                <td>
                  <span class="conference-table-text">Xoá</span>
                </td>
                <td
                  :class="column.class"
                  :key="column.layout"
                  v-for="column in headerConf"
                  v-on="column.sortColumnName&&{click: () => sortByColumn(column.sortColumnName)}"
                >
                  <span class="conference-table-text">
                    {{column.label}}
                    <b-icon
                      :class="sortableValue"
                      class="sort-icon"
                      icon="arrow-up"
                      size="is-small"
                      v-if="sortPartySetting&&sortPartySetting.type===column.sortColumnName"
                    />
                  </span>
                </td>
              </tr>
              <tbody class="table-body">
                <tr :key="jointParticipant.id" v-for="(jointParticipant) in filteredParticipants">
                  <td class="conference-checkbox-column">
                    <b-checkbox
                      v-model="selectedMediaParticipantIDs"
                      :native-value="jointParticipant.id"
                    ></b-checkbox>
                  </td>
                  <td>&nbsp;&nbsp;{{jointParticipant.index}}</td>
                  <td class="column__username">
                    <b-icon icon="user-circle" pack="fa" class="icon-user" />
                    <span>{{ decodeURI(jointParticipant.name) }}</span>
                  </td>
                  <td>
                    <button
                      class="button-update-name"
                      @click="openUpdateDisplayNameModal(jointParticipant)"
                    >Đổi tên</button>
                  </td>
                  <td>
                    {{jointParticipant.connectionStatus}} 
                    <span
                      @click="openDisconnectModal(jointParticipant)"
                      class="icon-conf"
                      v-if="jointParticipant.connectionStatus === 'connected'">
                      <img src="@/assets/images/icons/icon-connect_01.png" alt title="Ngắt kết nối" />
                    </span>
                  </td>
                  <td>
                    <button
                      class="button-update-name"
                      @click="openDeletePartyModal(jointParticipant)"
                    >Xoá</button>
                  </td>
                  <td>
                    <span
                      class="icon-conf icon-conf--no-hand"
                      title="Tắt audio từ người dùng"
                      v-if="jointParticipant.audioMuteEndpoint==='true'"
                    >
                      <b-icon icon="microphone-alt-slash" class="headphones-icon" size="is-medium" />
                    </span>
                  </td>
                  <td>
                    <span
                      @click="setMuteSingleAudioMCU(jointParticipant)"
                      class="icon-conf"
                      :class="[jointParticipant.audioMute === 'false' ? 'icon-audio' : 'icon-disable-audio']"
                      title="Trạng thái bật tắt micro"
                    ></span>
                  </td>
                  <td>
                    <span
                      class="icon-conf"
                      @click="toggleBlockAudioMCU(jointParticipant)"
                      title="Block audio"
                    >
                      <b-icon
                        :icon="jointParticipant.audioBlock === 'true'?'volume-mute':'volume-down'"
                        class="headphones-icon"
                        size="is-medium"
                      />
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-conf icon-conf--volume"
                      @click="selectVolumeMCU(jointParticipant)"
                    >
                      <b-icon
                        icon="sliders-h"
                        pack="fas"
                        class="share-icon enabled volume-icon"
                        size="is-medium"
                      />
                      <span class="volume-text">{{jointParticipant.volume}}</span>
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-conf icon-conf--volume"
                      @click="selectListenVolumeMCU(jointParticipant)"
                    >
                      <b-icon
                        icon="sliders-h"
                        pack="fas"
                        class="share-icon enabled volume-icon"
                        size="is-medium"
                      />
                      <span class="volume-text">{{jointParticipant.listenVolume}}</span>
                    </span>
                  </td>
                  <td>
                    <span
                      @click="setMuteSingleVideoMCU(jointParticipant)"
                      class="icon-conf"
                      :class="[jointParticipant.videoMute === 'false' ? 'icon-video' : 'icon-disable-video']"
                      title="Trạng thái camera"
                    ></span>
                  </td>
                  <td>
                    <span
                      class="icon-conf icon-conf--no-hand icon-conf--speaker"
                      title="Trạng thái speaker"
                    >
                      <div class="cover" v-if="jointParticipant.speaker">
                        <span class="icon-speaker speaker" />
                      </div>
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-conf"
                      title="Người phát biểu"
                      v-if="jointParticipant.lecturer"
                    >
                      <b-icon icon="chalkboard-teacher" class="lecturer-icon" size="is-medium" />
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-conf"
                      @click="openModalLayoutByParty(jointParticipant)"
                      title="Trạng thái layout của participant"
                    >
                      <img src="@/assets/images/icons/icon-layout.png" alt />
                    </span>
                  </td>
                  <td>
                    <span
                      class="icon-conf icon-conf--no-hand icon-share-content"
                      v-if="jointParticipant.isExclusiveContent==='true'"
                      title="Điểm cầu được phép chia sẻ content"
                    />
                  </td>
                  <td>
                    <span
                      class="icon-conf-other"
                      title="Trạng thái đang chia sẻ nội dung"
                      v-if="jointParticipant.shareContent === 'true'"
                    >
                      <b-icon
                        icon="share-alt"
                        pack="fas"
                        class="share-icon enabled"
                        size="is-medium"
                      />
                    </span>
                  </td>
                  <td>
                    <span class="icon-conf-other" title="Trạng thái giơ tay phát biểu">
                      <b-icon
                        type="is-info"
                        icon="hand-paper"
                        pack="fas"
                        class="hand-icon"
                        :class="{'enabled': jointParticipant.isHandup}"
                        size="is-medium"
                      />
                    </span>
                  </td>
                  <td>
                    <span title="Loại kết nối">{{jointParticipant.signalingProtocol}}</span>
                  </td>
                  <!-- <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.video_in&&jointParticipant.video_in.packetLoss}}</span>
                  </td>
                  <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.video_out&&jointParticipant.video_out.packetLoss}}</span>
                  </td>
                  <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.audio_in&&jointParticipant.audio_in.packetLoss}}</span>
                  </td>
                  <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.audio_out&&jointParticipant.audio_out.packetLoss}}</span>
                  </td>
                  <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.content_in&&jointParticipant.content_in.packetLoss}}</span>
                  </td>
                  <td class="has-text-centered">
                    <span
                      style="text-decoration: underline; color: blue; cursor: pointer;"
                      @click="selectPackageMCU(jointParticipant)"
                    >{{jointParticipant.content_out&&jointParticipant.content_out.packetLoss}}</span>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-collapse>
      <div v-if="selectedBookedParties" class="booked-room__conference">
        <div class="booked-room__conference-title">Người dùng được đăng ký vào phòng họp</div>
        <div>
          <span
            class="tag is-success booked-room__user"
            v-for="(party, index) in selectedBookedParties"
            :key="index"
          >{{party}}</span>
          <button
            class="button delete is-info button-delete-booked-parties"
            aria-label="close"
            @click="resetBookedParties"
          />
        </div>
      </div>
      <div class="conference-control">
        <div class="mb-10 conference-control__label has-text-centered">Điều khiển chung</div>
        <div class="conference-control__row">
          <div class="conference-control__column" @click="isOpenAllPackageModal=true">
            <button
              class="button is-info is-small button-setting-conf"
              slot="trigger"
              size="is-small"
            >
              <span>Giám sát chất lượng</span>
            </button>
          </div>
          <div class="conference-control__column" style="text-align: center;">
            <b-dropdown aria-role="list" position="is-top-right">
              <button
                class="button is-info is-small button-setting-conf"
                slot="trigger"
                size="is-small"
              >
                <span>Thiết lập</span>
              </button>
              <b-dropdown-item
                v-for="control in settingControls"
                :key="control.name"
                aria-role="listitem"
                @click="control.method"
              >{{control.name}}</b-dropdown-item>
            </b-dropdown>
            <div
              class="has-text-danger conference-media-error"
              v-if="isMediaButtonClicked&&selectedMediaParticipantIDs&&!selectedMediaParticipantIDs.length"
            >Vui lòng chọn participant</div>
          </div>
          <div class="conference-control__column" @click="isOpenPassCodeModal=true">
            <div class="conference-control__photo has-text-centered">
              <b-icon icon="book-reader" class="icon-phone-wrapper" />
            </div>
            <div
              class="conference-control__name has-text-centered conference-control__name--small"
            >Mật khẩu cuộc họp</div>
          </div>
          <div class="conference-control__column" @click="isLayoutModalActive=true">
            <div class="conference-control__photo has-text-centered">
              <img src="@/assets/images/icons/icon-layout.png" alt />
            </div>
            <div class="conference-control__name has-text-centered">Layout</div>
          </div>
          <div class="conference-control__column">
            <div class="conference-control__photo has-text-centered" @click="setMuteAllAudioMCU">
              <img src="@/assets/images/icons/icon-audio.png" alt v-if="!isAllMutedAudio" />
              <img src="@/assets/images/icons/icon-disable_audio.png" alt v-else />
            </div>
            <div class="conference-control__name has-text-centered">Bật/tắt all mic</div>
          </div>
          <div class="conference-control__column">
            <div class="conference-control__photo has-text-centered" @click="handleShareContent">
              <img src="@/assets/images/icons/icon-share_content.png" alt />
            </div>
            <div class="conference-control__name has-text-centered">Chia sẻ nội dung</div>
          </div>
          <div class="conference-control__column">
            <div
              class="conference-control__photo has-text-centered"
              @click="lockConferenceRoom"
              v-if="!isLocked"
            >
              <img
                src="@/assets/images/icons/icon-unlock.png"
                alt
                :class="{loading: isLoadingLocked}"
              />
            </div>
            <div
              class="conference-control__photo has-text-centered"
              @click="unLockConferenceRoom"
              v-else
              :class="{loading: isLoadingLocked}"
            >
              <img src="@/assets/images/icons/icon-lock.png" alt />
            </div>
            <div class="conference-control__name has-text-centered">Khoá phòng họp</div>
          </div>
          <div class="conference-control__column">
            <div class="conference-control__photo has-text-centered" @click="isOpenDialModal=true">
              <b-icon icon="phone" class="icon-phone-wrapper" />
            </div>
            <div class="conference-control__name has-text-centered">Thêm participant</div>
          </div>
          <div class="conference-control__column">
            <div
              class="conference-control__photo has-text-centered"
              @click="isOpenLecturerModal=true"
            >
              <b-icon icon="chalkboard-teacher" class="icon-phone-wrapper" />
            </div>
            <div
              class="conference-control__name conference-control__name--small has-text-centered"
            >Chọn điểm cầu phát biểu</div>
          </div>
          <div class="conference-control__column">
            <div class="conference-control__photo has-text-centered" @click="reloadPartyListMCU">
              <b-icon icon="redo" class="icon-phone-wrapper" />
            </div>
            <div class="conference-control__name has-text-centered">Tải lại</div>
          </div>
          <div class="conference-control__column">
            <div
              class="conference-control__photo has-text-centered"
              @click="isBookedRoomModalActive=true"
            >
              <b-icon icon="list-ul" class="icon-phone-wrapper" />
            </div>
            <div
              class="conference-control__name conference-control__name--small has-text-centered"
            >Chọn người được tham gia họp</div>
          </div>
          <div class="conference-control__column">
            <div
              class="conference-control__photo has-text-centered"
              @click="isAllDisconnectModalActive=true"
            >
              <img src="@/assets/images/icons/icon-connect_01.png" alt />
            </div>
            <div class="conference-control__name has-text-centered">Ngắt kết nối</div>
          </div>
          <div class="conference-control__column">
            <div
              class="conference-control__photo has-text-centered"
              @click="isRemoveConfModalActive=true"
            >
              <b-icon icon="trash" class="icon-phone-wrapper" />
            </div>
            <div class="conference-control__name has-text-centered">Xoá cuộc họp</div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isLayoutModalActive" class="modal--layout">
      <div class="content-layout">
        <header class="modal-card-head">
          <p class="modal-card-title">Layout</p>
          <button class="delete" aria-label="close" @click="isLayoutModalActive=false" />
        </header>
        <div class="content-layout__inner">
          <ul class="content-layout__list">
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1x1', 1)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-01.png" />
              </span>
              <div class="has-text-centered body-text">1x1</div>
              <input
                type="radio"
                :checked="selectedLayout==='1x1'"
                @click="changeLayoutImage('1x1', 1)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1x2', 2)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-02.png" />
              </span>
              <div class="has-text-centered body-text">1x2</div>
              <input
                type="radio"
                :checked="selectedLayout==='1x2'"
                @click="changeLayoutImage('1x2', 2)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1and3', 4)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-03.png" />
              </span>
              <div class="has-text-centered body-text">3+1Vert</div>
              <input
                type="radio"
                :checked="selectedLayout==='1and3'"
                @click="changeLayoutImage('1and3', 4)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('2x2', 4)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-04.png" />
              </span>
              <div class="has-text-centered body-text">2x2</div>
              <input
                type="radio"
                :checked="selectedLayout==='2x2'"
                @click="changeLayoutImage('2x2', 4)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1and5', 6)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-05.png" />
              </span>
              <div class="has-text-centered body-text">5+1</div>
              <input
                type="radio"
                :checked="selectedLayout==='1and5'"
                @click="changeLayoutImage('1and5', 6)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1and7', 8)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-06.png" />
              </span>
              <div class="has-text-centered body-text">7+1</div>
              <input
                type="radio"
                :checked="selectedLayout==='1and7'"
                @click="changeLayoutImage('1and7', 8)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('3x3', 9)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-07.png" />
              </span>
              <div class="has-text-centered body-text">3x3</div>
              <input
                type="radio"
                :checked="selectedLayout==='3x3'"
                @click="changeLayoutImage('3x3', 9)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('2and8', 10)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-08.png" />
              </span>
              <div class="has-text-centered body-text">8+2</div>
              <input
                type="radio"
                :checked="selectedLayout==='2and8'"
                @click="changeLayoutImage('2and8', 10)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('1and12', 13)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-09.png" />
              </span>
              <div class="has-text-centered body-text">12+1</div>
              <input
                type="radio"
                :checked="selectedLayout==='1and12'"
                @click="changeLayoutImage('1and12', 13)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('4x4', 16)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-10.png" />
              </span>
              <div class="has-text-centered body-text">4x4</div>
              <input
                type="radio"
                :checked="selectedLayout==='4x4'"
                @click="changeLayoutImage('4x4', 16)"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changeLayoutImage('4x5', 20)">
                <img class="content-layout__img" src="@/assets/images/layout/layout-11.png" />
              </span>
              <div class="has-text-centered body-text">4x5</div>
              <input
                type="radio"
                :checked="selectedLayout==='4x5'"
                @click="changeLayoutImage('4x5', 20)"
              />
            </li>
          </ul>
          <div class="container_layout _1x1" v-if="selectedLayout==='1x1'">
            <div class="cell cell1">
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===1
                  })"
                class="share-content-controller"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: 1})"
              />
            </div>
          </div>
          <div class="container_layout _1x2" v-if="selectedLayout==='1x2'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 2}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _3and1Vert" v-if="selectedLayout==='1and3'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 4}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _2x2" v-if="selectedLayout==='2x2'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 4}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _5and1" v-if="selectedLayout==='1and5'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 6}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _7and1" v-if="selectedLayout==='1and7'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 8}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                      const temp = selectedLayoutParty.find(person => person.id === party.id)
                      return temp&&temp.cell===idx
                    })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _3x3" v-if="selectedLayout==='3x3'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 9}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _8and2" v-if="selectedLayout==='2and8'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 10}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _12and1" v-if="selectedLayout==='1and12'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 13}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _4x4" v-if="selectedLayout==='4x4'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 16}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _4x5" v-if="selectedLayout==='4x5'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 20}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const temp = selectedLayoutParty.find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setselectedPartyLayoutList({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="isLayoutModalActive=false">Huỷ</button>
          </div>
          <div class="control">
            <button class="button is-info" @click="setAutoLayoutMCUView">Chỉnh mặc định</button>
          </div>
          <div class="control">
            <button class="button is-info" @click="saveLayoutMCU">Lưu</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isShareContentModalActive">
      <div class="content-layout content-layout--share-content">
        <header class="modal-card-head">
          <p class="modal-card-title">Chia sẻ nội dung</p>
          <button class="delete" aria-label="close" @click="isShareContentModalActive=false" />
        </header>
        <form @submit.prevent="enableExclusiveShareContent" data-vv-scope="shareContentForm">
          <div class="content-layout__inner">
            <div class="has-text-centered body-text">Điểm cầu được phép chia sẻ content</div>
            <div class="has-text-centered share-content-group body-text">
              Chọn điểm cầu chia sẻ:
              <span class="has-text-danger">*</span>
              <div class="select-share-content">
                <b-field
                  :type="{'is-danger': errors.has('shareContentForm.party')}"
                  :message="errors.first('shareContentForm.party')"
                  custom-class="has-text-weight-normal body-text"
                >
                  <v-select
                    name="party"
                    label="name"
                    :options="orderedParties"
                    @input="updateSelectedParty"
                    class="share-content-controller"
                    v-model="selectedShareParty"
                    v-validate="'required'"
                    data-vv-as="Điểm cầu chia sẻ"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <div
            class="modal-bottom-group modal-bottom-group--share-content field is-grouped is-grouped-centered"
          >
            <div class="control">
              <div
                class="button-share-content button is-danger"
                :class="{loading: isLoading}"
                @click="resetShareContentParty"
              >Xoá</div>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Đồng ý</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenDialModal">
      <div class="content-layout content-layout--dial">
        <header class="modal-card-head">
          <p class="modal-card-title">Thêm participant</p>
          <button aria-label="close" class="delete" @click="isOpenDialModal=false" />
        </header>
        <div class="content-layout__inner">
          <b-checkbox v-model="checkboxDialOutIPID">Thêm điểm cầu bằng IP/ID</b-checkbox><br>
          <form @submit.prevent="createDialOut" data-vv-scope="dialOut" v-show="!checkboxDialOutIPID">
            <div class="form-user">
              <b-field
                :message="errors.first('dialOut.selectList')"
                :type="{'is-danger': errors.has('dialOut.selectList')}"
                custom-class="has-text-weight-normal body-text">
                <template slot="label">Chọn người dùng</template>
                <v-select
                  :options="filterDeviceList"
                  @input="updateDialParticipant"
                  class="select-participant"
                  data-vv-as="Người dùng"
                  label="firstName"
                  multiple
                  name="selectList"
                  v-model="handedDialOut"
                  v-validate="'required'"
                />
              </b-field>
              <b-field
                :message="errors.first('dialOut.dialType')"
                :type="{'is-danger': errors.has('dialOut.dialType')}"
                custom-class="has-text-weight-normal body-text"
              >
                <template slot="label">
                  Kiểu dial
                  <span class="has-text-danger">*</span>
                </template>
                <v-select
                  :options="['h323', 'sip']"
                  data-vv-as="Kiểu dial"
                  name="dialType"
                  v-model="dialOut.type"
                  v-validate="'required'"
                />
              </b-field>
              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isOpenDialModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button type="is-info" native-type="submit">Thêm</b-button>
                </div>
              </div>
            </div>
          </form>
          <form @submit.prevent="dialOutByIPID" data-vv-scope="dialOutIDIP" v-show="checkboxDialOutIPID">
            <div class="form-user">
              <b-field
                :message="errors.first('dialOutIDIP.dialType')"
                :type="{'is-danger': errors.has('dialOutIDIP.dialType')}"
                custom-class="has-text-weight-normal body-text"
              >
                <template slot="label">
                  Kiểu dial
                  <span class="has-text-danger">*</span>
                </template>
                <v-select
                  :options="['h323', 'sip']"
                  data-vv-as="Kiểu dial"
                  name="dialType"
                  v-model="dialOut.type"
                  v-validate="'required'"
                />
              </b-field>
              <b-field
                :message="errors.first('dialOutIDIP.dialOutName')"
                :type="{'is-danger': errors.has('dialOutIDIP.dialOutName')}"
                custom-class="has-text-weight-normal body-text"
              >
                <template slot="label">
                  Tên
                  <span class="has-text-danger">*</span>
                </template>
                <b-input
                  v-model="dialOut.name"
                  type="text"
                  name="dialOutName"
                  size="is-medium"
                  v-validate="'required'"
                  data-vv-as="Tên"
                />
              </b-field>
              <b-field
                :message="errors.first('dialOutIDIP.dialOutString')"
                :type="{'is-danger': errors.has('dialOutIDIP.dialOutString')}"
                custom-class="has-text-weight-normal body-text"
              >
                <template slot="label">
                  IP điểm cầu
                  <span class="has-text-danger">*</span>
                </template>
                <b-input
                  data-vv-as="IP điểm cầu"
                  name="dialOutString"
                  size="is-medium"
                  type="text"
                  v-model="dialOut.text"
                  v-validate="'required'"
                />
              </b-field>
              <b-field custom-class="has-text-weight-normal body-text">
                <template slot="label">ID điểm cầu</template>
                <b-input
                  v-model="dialOut.id"
                  type="text"
                  name="dialOutID"
                  size="is-medium"
                  data-vv-as="ID điểm cầu"
                />
              </b-field>
              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <b-button @click="isOpenDialModal=false">Đóng</b-button>
                </div>
                <div class="control">
                  <b-button type="is-info" native-type="submit">Thêm IP/ID</b-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenLecturerModal" class="modal--lecturer">
      <div class="content-layout content-layout--lecturer">
        <header class="modal-card-head">
          <p class="modal-card-title">Chọn người phát biểu</p>
          <button aria-label="close" class="delete" @click="isOpenLecturerModal=false" />
        </header>
        <form @submit.prevent="setLecturerChannelMCU">
          <div class="content-layout__inner">
            <div class="field is-grouped is-grouped-multiline is-grouped-centered">
              <div class="control">
                <b-field
                  custom-class="has-text-weight-normal body-text"
                  :type="{'is-danger': errors.has('setLecturer.lecturer')}"
                  :message="errors.first('setLecturer.lecturer')"
                >
                  <template slot="label">
                    Chọn người phát biểu
                    <span class="has-text-danger">*</span>
                  </template>
                  <multiselect
                    v-model="selectedLecturer"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label="name"
                    placeholder
                    :options="orderedParties"
                    :searchable="true"
                    :allow-empty="true"
                    :show-labels="false"
                    data-vv-scope="setLecturer"
                    v-validate="'required'"
                    name="lecturer"
                    data-vv-as="Chọn người phát biểu"
                  >
                    <template slot-scope="{ option }">{{ option.name }}</template>
                  </multiselect>
                </b-field>
              </div>
            </div>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button
                type="is-danger"
                @click="unselectLecturerMCU"
                v-if="selectedLecturer!=='Chọn điểm cầu phát biểu'"
              >Bỏ chọn người phát biểu</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Đồng ý</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isPartyLayoutModalActive">
      <div class="content-layout">
        <header class="modal-card-head">
          <p class="modal-card-title">Layout</p>
          <button class="delete" aria-label="close" @click="isPartyLayoutModalActive=false" />
        </header>
        <div class="content-layout__inner">
          <ul class="content-layout__list">
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1x1')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-01.png" />
              </span>
              <div class="has-text-centered body-text">1x1</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1x1'"
                @click="changePartyLayoutImage('1x1')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1x2')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-02.png" />
              </span>
              <div class="has-text-centered body-text">1x2</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1x2'"
                @click="changePartyLayoutImage('1x2')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1and3Ver')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-03.png" />
              </span>
              <div class="has-text-centered body-text">3+1Vert</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and3Ver'"
                @click="changePartyLayoutImage('1and3Ver')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('2x2')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-04.png" />
              </span>
              <div class="has-text-centered body-text">2x2</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='2x2'"
                @click="changePartyLayoutImage('2x2')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1and5')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-05.png" />
              </span>
              <div class="has-text-centered body-text">5+1</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and5'"
                @click="changePartyLayoutImage('1and5')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1and7')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-06.png" />
              </span>
              <div class="has-text-centered body-text">7+1</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and7'"
                @click="changePartyLayoutImage('1and7')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('3x3')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-07.png" />
              </span>
              <div class="has-text-centered body-text">3x3</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='3x3'"
                @click="changePartyLayoutImage('3x3')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('2and8')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-08.png" />
              </span>
              <div class="has-text-centered body-text">8+2</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='2and8'"
                @click="changePartyLayoutImage('2and8')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('1and12')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-09.png" />
              </span>
              <div class="has-text-centered body-text">12+1</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and12'"
                @click="changePartyLayoutImage('1and12')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('4x4')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-10.png" />
              </span>
              <div class="has-text-centered body-text">4x4</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='4x4'"
                @click="changePartyLayoutImage('4x4')"
              />
            </li>
            <li>
              <span class="content-layout__item" @click="changePartyLayoutImage('4x5')">
                <img class="content-layout__img" src="@/assets/images/layout/layout-11.png" />
              </span>
              <div class="has-text-centered body-text">4x5</div>
              <input
                type="radio"
                :checked="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='4x5'"
                @click="changePartyLayoutImage('4x5')"
              />
            </li>
          </ul>
          <div class="container_layout _1x1" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1x1'">
            <div class="cell cell1">
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===1
                  })"
                class="share-content-controller"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: 1})"
              />
            </div>
          </div>
          <div class="container_layout _1x2" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1x2'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 2}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _3and1Vert" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and3Ver'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 4}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _2x2" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='2x2'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 4}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _5and1" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and5'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 6}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _7and1" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and7'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 8}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _3x3" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='3x3'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 9}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _8and2" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='2and8'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 10}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _12and1" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='1and12'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 13}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _4x4" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='4x4'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 16}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
          <div class="container_layout _4x5" v-if="selectedPartyLayoutList&&selectedPartyLayoutList[rowPartyLayout.id]==='4x5'">
            <div
              :class="`cell cell${idx}`"
              v-for="idx in Array.from({length: 20}, (_, i) => i + 1)"
              :key="idx"
            >
              <v-select
                name="party"
                label="name"
                :options="orderedParties"
                :value="orderedParties.find(party => {
                    const partyId = rowPartyLayout.id
                    const temp = forcedLayoutParty&&forcedLayoutParty[partyId]&&forcedLayoutParty[partyId].find(person => person.id === party.id)
                    return temp&&temp.cell===idx
                  })"
                @input="(evt) => setForcedPartyLayout({id: evt&&evt.id||null, cell: idx})"
              />
            </div>
          </div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="isPartyLayoutModalActive=false">Huỷ</button>
          </div>
          <div class="control">
            <button class="button is-info" @click="resetLayoutByParty">Chỉnh mặc định</button>
          </div>
          <div class="control">
            <button class="button is-info" @click="setLayoutByParty">Lưu</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isBookedRoomModalActive">
      <div class="content-layout content-layout--booked-room">
        <header class="modal-card-head">
          <p class="modal-card-title">Chọn người được tham gia họp</p>
          <button class="delete" aria-label="close" @click="isBookedRoomModalActive=false" />
        </header>
        <div class="content-layout__inner">
          <div v-for="(roomInfo) in bookedRoomList" :key="roomInfo._id" class="columns">
            <div class="column booked-room__flex">
              <span class="booked-room__radio">
                <input
                  type="radio"
                  name="radioBookedRoom"
                  @click="selectBookedRoom(roomInfo.participants)"
                />
              </span>
              <span class="booked-room__tag">
                <span
                  class="tag is-success booked-room__user"
                  v-for="(party, index) in roomInfo.participants"
                  :key="index"
                >{{party}}</span>
              </span>
            </div>
            <div class="column is-one-third">{{roomInfo.title}}</div>
          </div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="cancelBookedRoom">Huỷ</button>
          </div>
          <div class="control">
            <button class="button is-info" @click="filterConnect">Lọc kết nối</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isAllDisconnectModalActive">
      <div class="content-layout content-layout--booked-room">
        <header class="modal-card-head">
          <p class="modal-card-title">Ngắt kết nối tất cả participant</p>
          <button class="delete" aria-label="close" @click="isAllDisconnectModalActive=false" />
        </header>
        <div class="content-layout__inner body-text">Vui lòng xác nhận ngắt kết nối</div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="isAllDisconnectModalActive=false">Đóng</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click="disconnectAllActivePartyMCU">Ngắt kết nối</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isRemoveConfModalActive">
      <div class="content-layout content-layout--booked-room">
        <header class="modal-card-head">
          <p class="modal-card-title">Xoá cuộc họp</p>
          <button class="delete" aria-label="close" @click="isRemoveConfModalActive=false" />
        </header>
        <div class="content-layout__inner body-text">Vui lòng xác nhận xoá cuộc họp</div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="isRemoveConfModalActive=false">Đóng</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click="terminateMCU">Xoá</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isDisconnectModalActive">
      <div class="content-layout content-layout--booked-room">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
          >Ngắt kết nối participant {{selectedDisconnectParty&&selectedDisconnectParty.name}}</p>
          <button class="delete" aria-label="close" @click="isDisconnectModalActive=false" />
        </header>
        <div class="content-layout__inner body-text">Vui lòng xác nhận ngắt kết nối</div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <button class="button" @click="isDisconnectModalActive=false">Đóng</button>
          </div>
          <div class="control">
            <button
              class="button is-danger"
              @click="disconnectPartyMCUView(selectedDisconnectParty)"
            >Ngắt kết nối</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isDisplayNameModalActive">
      <div class="content-layout content-layout--booked-room">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Đổi tên hiển thị cho
            <i>{{selectedDisplayParty&&selectedDisplayParty.name}}</i>
          </p>
          <button class="delete" aria-label="close" @click="isDisplayNameModalActive=false" />
        </header>
        <form @submit.prevent="updateDisplayNameMCU" data-vv-scope="formDisplayName">
          <div class="content-layout__inner body-text">
            <div class="form-user">
              <b-field
                :type="{'is-danger': errors.has('formDisplayName.displayTextName')}"
                :message="errors.first('formDisplayName.displayTextName')"
                custom-class="has-text-weight-normal body-text"
              >
                <template slot="label">
                  Tên hiển thị
                  <span class="has-text-danger">*</span>
                </template>
                <b-input
                  v-model="displayName"
                  name="displayTextName"
                  v-validate="{required: true, min: 4, regex: /\w$/}"
                  size="is-medium"
                  data-vv-as="Tên hiển thị"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button @click="isDisplayNameModalActive=false">Đóng</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Cập nhật</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenPassCodeModal">
      <div class="content-layout content-layout--passcode">
        <header class="modal-card-head">
          <p class="modal-card-title">Tạo mật khẩu cuộc họp</p>
          <button aria-label="close" class="delete" @click="isOpenPassCodeModal=false" />
        </header>
        <form @submit.prevent="createPasscode" data-vv-scope="passCodeForm">
          <div class="content-layout__inner">
            <div class="form-user">
              <b-field
                :type="{'is-danger': errors.has('passCodeForm.new-pass-code')}"
                :message="errors.first('passCodeForm.new-pass-code')"
                custom-class="has-text-weight-normal"
              >
                <template slot="label">
                  Mật khẩu
                  <span class="has-text-danger">*</span>
                </template>
                <b-input
                  v-model="newPasscode"
                  type="number"
                  name="new-pass-code"
                  size="is-medium"
                  v-validate="'required'"
                  data-vv-as="Mật khẩu"
                  ref="newPassCode"
                />
              </b-field>
            </div>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button @click="isOpenPassCodeModal=false">Đóng</b-button>
            </div>
            <div class="control">
              <b-button type="is-danger" @click="isResetPassCodeModal=true">Xoá</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Thay đổi</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isResetPassCodeModal">
      <div class="content-layout content-layout--passcode">
        <header class="modal-card-head">
          <p class="modal-card-title">Xoá mật khẩu cuộc họp</p>
          <button aria-label="close" class="delete" @click="isResetPassCodeModal=false" />
        </header>
        <div class="content-layout__inner">
          <div>Xin xác nhận xoá mật khẩu cuộc họp?</div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <b-button @click="isResetPassCodeModal=false">Đóng</b-button>
          </div>
          <div class="control">
            <b-button type="is-danger" @click="deletePasscode">Xoá</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isSetVolumeModal" class="modal--volume">
      <div class="content-layout content-layout--passcode">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
          >Thay đổi âm lượng nói của {{selectedParticipant&&selectedParticipant.name}}</p>
          <button aria-label="close" class="delete" @click="isSetVolumeModal=false" />
        </header>
        <form @submit.prevent="updateVolumeMCU" data-vv-scope="volumeForm">
          <div class="content-layout__inner">
            <b-field
              :type="{'is-danger': errors.has('volumeForm.volume-input')}"
              :message="errors.first('volumeForm.volume-input')"
              custom-class="has-text-weight-normal body-text"
            >
              <template slot="label">
                Điều chỉnh âm lượng
                <span class="has-text-danger">*</span>
              </template>
              <v-select
                name="volume-input"
                :options="Array.from({length: 10}, (_, i) => i + 1)"
                v-model="selectedVolume"
                class="share-content-controller"
                v-validate="'required'"
                data-vv-as="âm lượng nói"
              />
            </b-field>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button @click="isSetVolumeModal=false">Đóng</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Cập nhật</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isSetListenVolumeModal" class="modal--volume">
      <div class="content-layout content-layout--passcode">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
          >Thay đổi âm lượng nghe của {{selectedParticipant&&selectedParticipant.name}}</p>
          <button aria-label="close" class="delete" @click="isSetListenVolumeModal=false" />
        </header>
        <form @submit.prevent="updateListenVolumeMCU" data-vv-scope="listenVolumeForm">
          <div class="content-layout__inner">
            <b-field
              :type="{'is-danger': errors.has('listenVolumeForm.volume-listen-input')}"
              :message="errors.first('listenVolumeForm.volume-listen-input')"
              custom-class="has-text-weight-normal body-text"
            >
              <template slot="label">
                Điều chỉnh âm lượng
                <span class="has-text-danger">*</span>
              </template>
              <v-select
                name="volume-listen-input"
                :options="Array.from({length: 10}, (_, i) => i + 1)"
                v-model="selectedListenVolume"
                class="share-content-controller"
                v-validate="'required'"
                data-vv-as="âm lượng nghe"
              />
            </b-field>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button @click="isSetListenVolumeModal=false">Đóng</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Cập nhật</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenPackageModal" full-screen class="package-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">{{selectedParticipant&&selectedParticipant.name}}</p>
        <button aria-label="close" class="delete" @click="isOpenPackageModal=false" />
      </header>
      <div class="content-layout__inner">
        <table class="table is-fullwidth table-package">
          <tr>
            <td
              v-for="(category) in ['Bite rate video in', 'Bite rate video out', 'Bite rate audio in', 'Bite rate audio out', 'Bite rate content in', 'Bite rate content out', 'Packet loss video in', 'Packet loss video out', 'Packet loss audio in', 'Packet loss audio out', 'Packet loss content in', 'Packet loss content out', 'Fraction loss video in (Peak)', 'Fraction loss video out (Peak)', 'Fraction loss audio in (Peak)', 'Fraction loss audio out (Peak)', 'Fraction loss content in (Peak)', 'Fraction loss content out (Peak)', 'Jitter video in', 'Jitter video out', 'Jitter audio in', 'Jitter audio out', 'Jitter content in', 'Jitter content out']"
              :key="`${category}`"
            >{{category}}</td>
          </tr>
          <tr v-if="selectedParticipant">
            <td
              v-for="(category) in ['video_in', 'video_out', 'audio_in', 'audio_out', 'content_in', 'content_out']"
              :key="`${category}bitRate`"
            >{{selectedParticipant[category]['bitRate']}}</td>
            <td
              v-for="(category) in ['video_in', 'video_out', 'audio_in', 'audio_out', 'content_in', 'content_out']"
              :key="`${category}packetLoss`"
            >{{selectedParticipant[category]['packetLoss']}}</td>
            <td
              v-for="(category) in ['video_in', 'video_out', 'audio_in', 'audio_out', 'content_in', 'content_out']"
              :key="`${category}fractionLoss`"
            >{{selectedParticipant[category]['fractionLoss']}}% ({{selectedParticipant[category]['fractionLossPeak']}}%)</td>
            <td
              v-for="(category) in ['video_in', 'video_out', 'audio_in', 'audio_out', 'content_in', 'content_out']"
              :key="`${category}jitter`"
            >{{selectedParticipant[category]['jitter']}}</td>
          </tr>
        </table>
      </div>
      <div class="modal-bottom-group field is-grouped is-grouped-centered">
        <div class="control">
          <b-button @click="isOpenPackageModal=false">Đóng</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenAllPackageModal" full-screen class="package-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">Giám sát chất lượng</p>
        <button aria-label="close" class="delete" @click="isOpenAllPackageModal=false" />
      </header>
      <div class="content-layout__inner">
        <b-table
          :data="jointParticipants.map((party, index) => {
            return {
              ...party,
              index: (index+1),
            }
          })"
          :default-sort-direction="'asc'"
          :paginated="false"
          :sort-icon="'arrow-up'"
          :sort-icon-size="'is-small'"
          :sticky-header="true"
          class="table is-fullwidth table-package table-all-loss-package"
          default-sort="name"
          v-if="jointParticipants&&jointParticipants.length">
            <template slot-scope="props">
              <b-table-column
                :field="data.field"
                :key="data.field"
                :label="data.label"
                sortable
                v-for="data in tableLossPackage">
                {{ data.value(props.row) }}<span v-if="data.field.split('.').includes('fractionLoss')">%</span>&nbsp;<span v-if="data.valuePeak">({{data.valuePeak(props.row)}}%)</span>
              </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="modal-bottom-group field is-grouped is-grouped-centered">
        <div class="control">
          <b-button @click="isOpenAllPackageModal=false">Đóng</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isDeletePartyMCUModal">
      <div class="content-layout">
        <header class="modal-card-head">
          <p class="modal-card-title">Xoá điểm cầu {{selectedParticipant&&selectedParticipant.name}}</p>
          <button aria-label="close" class="delete" @click="isDeletePartyMCUModal=false" />
        </header>
        <div class="content-layout__inner">
          <div>Xin xác nhận xoá điểm cầu</div>
        </div>
        <div class="modal-bottom-group field is-grouped is-grouped-centered">
          <div class="control">
            <b-button @click="isDeletePartyMCUModal=false">Đóng</b-button>
          </div>
          <div class="control">
            <b-button @click="deletePartyMCUView" type="is-danger">Xoá</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import { mapState, mapActions, mapMutations } from "vuex";
import { socket } from "../config";
import moment from "moment";
import RoomService from "../services/RoomService";
import vSelect from "vue-select";
import Vue from "vue";
import Utils from "../components/shared/Utils";
import { get } from "lodash";

Vue.component("downloadExcel", JsonExcel);
Vue.component("v-select", vSelect);

export default {
  components: {
    Multiselect: () => import("vue-multiselect")
  },
  data() {
    return {
      bookedIntervalId: 0,
      conferenceId: null,
      checkboxDialOutIPID: false,
      dialOut: {
        name: "",
        text: "",
        type: "",
        id: ''
      },
      deviceList: [],
      disconnectedUsers: null,
      displayName: "",
      displayNameRoom: "",
      handedDialOut: null,
      host_MCU: null,
      isAllDisconnectModalActive: false,
      isBookedRoomModalActive: false,
      isDeletePartyMCUModal: false,
      isDisplayNameModalActive: false,
      isDisconnectModalActive: false,
      isOpenDialModal: false,
      isLayoutModalActive: false,
      isShareContentModalActive: false,
      isLoading: false,
      isLoadingLocked: false,
      isLocked: false,
      isOpenLecturerModal: false,
      isPartyLayoutModalActive: false,
      isOpenPassCodeModal: false,
      isResetPassCodeModal: false,
      isMediaButtonClicked: false,
      isSetVolumeModal: false,
      isSetListenVolumeModal: false,
      isOpenPackageModal: false,
      isOpenAllPackageModal: false,
      isRemoveConfModalActive: false,
      keywordPartyName: "",
      newPasscode: null,
      participants: [],
      partyIntervalId: 0,
      realtimeHandup: [],
      refusedParties: [],
      roomId: null,
      selectedParticipant: null,
      selectedLayout: "",
      selectedLayoutParty: [],
      forcedLayoutParty: null,
      selectedLecturer: null,
      rowPartyLayout: null,
      selectedPartyLayoutList: "",
      selectedBookedParties: null,
      selectedDisconnectParty: null,
      selectedDisplayParty: null,
      selectedShareParty: null,
      sortableValue: "asc",
      selectedMediaParticipantIDs: [],
      layoutParty: [],
      roomID_MCU: null,
      sidebar: [
        {
          title: "Quản lý phòng họp",
          icon: "icon-conf_control.png",
          url: "/ongoing-conference-list"
        },
        {
          title: "Quản lý người dùng",
          icon: "icon-address.png",
          url: "/user-management"
        },
        {
          title: "Tạo lịch họp",
          icon: "icon-schedule.png",
          url: "/calendar"
        },
        {
          title: "Lọc người tham gia phòng họp",
          icon: "icon-reservation.png",
          url: "/passcode-room-management"
        }
      ],
      selectedVolume: null,
      selectedListenVolume: null,
      selectedCell: 0,
      selectedAllMediaParticipantIDs: false,
      settingControls: [
        {
          method: () => this.unmuteAudioPartyListMCU(),
          name: "Bật mic điểm cầu đã chọn"
        },
        {
          method: () => this.muteAudioPartyListMCU(),
          name: "Tắt mic điểm cầu đã chọn"
        },
        {
          method: () => this.unmuteVideoPartyListMCU(),
          name: "Bật video điểm cầu đã chọn"
        },
        {
          method: () => this.muteVideoPartyListMCU(),
          name: "Tắt video điểm cầu đã chọn"
        },
        {
          method: () => this.muteAudioBlockPartyListMCU(),
          name: "Bật block audio điểm cầu đã chọn"
        },
        {
          method: () => this.unmuteAudioBlockPartyListMCU(),
          name: "Tắt block audio điểm cầu đã chọn"
        }
      ],
      json_fields: {
        "STT.": "partyId",
        Participant: "name",
        Time: "time",
        "Start Time": "startTime",
        "End Time": "endTime",
        "Disconnection Cause": "disconnectionCause",
        "Bite rate video in": "biteRateVideoIn",
        "Bite rate video out": "biteRateVideoOut",
        "Bite rate audio in": "biteRateAudioIn",
        "Bite rate audio out": "biteRateAudioOut",
        "Bite rate content in": "biteRateContentIn",
        "Bite rate content out": "biteRateContentOut",
        "Packet loss video in": "packetLossVideoIn",
        "Packet loss video out": "packetLossVideoOut",
        "Packet loss audio in": "packetLossAudioIn",
        "Packet loss audio out": "packetLossAudioOut",
        "Packet loss content in": "packetLossContentIn",
        "Packet loss content out": "packetLossContentOut",
        "Fraction loss video in (Peak)": "fractionLossVideoIn",
        "Fraction loss video out (Peak)": "fractionLossVideoOut",
        "Fraction loss audio in (Peak)": "fractionLossAudioIn",
        "Fraction loss audio out (Peak)": "fractionLossAudioOut",
        "Fraction loss content in (Peak)": "fractionLossContentIn",
        "Fraction loss content out (Peak)": "fractionLossContentOut",
        "Jitter video in": "jitterVideoIn",
        "Jitter video out": "jitterVideoOut",
        "Jitter audio in": "jitterAudioIn",
        "Jitter audio out": "jitterAudioOut",
        "Jitter content in": "jitterContentIn",
        "Jitter content out": "jitterContentOut",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      totalConnect: 0,
      totalDisconnect: 0,

      isTimer: false,
      timeList: [2, 5, 10, 15],
      timeSelected: null
    };
  },
  created() {
    this.roomID_MCU = this.$route.query.roomID_MCU;
    const id = this.$route.query.id;
    this.host_MCU =
      this.$store.state.room.conferenceIdentityList.find(room => {
        return room.id == id;
      }).host_MCU || undefined;
    this.conferenceId = this.$route.query.confId;

    // get address dial book
    this.getParticipants(this.$store.state.auth.entityTag).then(res => {
      this.participants = res;
    });
    this.getParticipantsByAdmin();

    this.getConfPartyByMCU({
      conferenceId: this.conferenceId,
      roomID_MCU: this.roomID_MCU,
      host_MCU: this.host_MCU
    }).then(() => {
      this.getRealtimeData();
    });

    this.getCurrentConferenceIdForAddText({
      conferenceId: this.conferenceId
    }).then(res => {
      const data = res.data;
      if (data.status) {
        this.isTimer = data.timer;
      }
    });

    this.getBookedRooms();

    this.getPartyListInterval();
  },
  beforeDestroy() {
    clearTimeout(this.partyIntervalId);
    clearInterval(this.bookedIntervalId);
  },
  methods: {
    ...mapActions("hostDevice", ["fetchDevicesByUser"]),
    ...mapActions("participant", ["getParticipants", "getParticipantsByAdmin"]),
    ...mapActions("room", [
      "changeDisplayNameParty", "changeDisplayNamePartyMCU",
      "deleteParticipant", "deletePartyMCU", "disconnectAllPartyMCU",
      "disconnectPartyMCU", "disconnectAllParty",
      "exportConferenceInfo",
      "getBookedRooms",
      "getJointParticipantsByConfId",
      "getRooms", "getConferenceIdList",
      "getPartyPacket", "getConfPartyByMCU",
      "lockConference",
      "muteAll", "muteAudio", "muteVideo",
      "muteVideoMCU", "muteAllMCU",
      "muteAudioMCU",
      "resetDefaultLayout", "resetPartyLayout",
      "resetShareContentByParticipant",
      "setLayout",
      "setShareContentParticipant",
      "setDialOut", "setLecturer",
      "setLecturerMCU", "setPartyLayout",
      "setLayoutConfMCU", "setListenVolumeMCU",
      "setVolumeMCU", "setLayoutMCU",
      "setAutoLayoutMCU", "setDialOutByIPID",
      "updateConferencePasswordMCU",
      "unLockConference",
      "updateBlockAudioMCU",
      "unmuteAll",

      "getCurrentConferenceIdForAddText",
      "setCurrentConferenceIdForAddText"
    ]),
    ...mapMutations("room", ["sortData"]),
    async fetchDataToExport() {
      const token = this.$store.state.auth.token;
      const username = this.$store.state.auth.username;
      this.disconnectedUsers = await RoomService.exportCDRSParties(
        {
          owner: username,
          roomID_MCU: this.roomID_MCU,
          host_MCU: this.host_MCU
        },
        token
      ).then(res => {
        if (res.data.status) {
          return res.data.data;
        }
        return [];
      });
      const newParties = this.jointParticipants.map(party => {
        const newPer = { ...party };
        newPer.partyId = newPer.id;
        return newPer;
      });
      const today = Date.now()
      this.totalConnect =
        (this.jointParticipants && this.jointParticipants.length) || 0;
      this.totalDisconnect = (this.disconnectedUsers && this.disconnectedUsers.length) || 0;
      return [...newParties, ...this.disconnectedUsers]
        .sort((party1, party2) => {
          return party1.partyId.localeCompare(party2.partyId, "en", {
            numeric: true
          });
        })
        .map(party => {
          const newParty = { ...party };
          const fractionLossVideoIn = `${get(newParty, "video_in.fractionLoss")||0}% (${get(newParty, "video_in.fractionLossPeak")||0}%)`
          let fractionLossVideoOut = `${get(newParty, "video_out.fractionLoss")||0}% (${get(newParty, "video_out.fractionLossPeak")||0}%)`
          let fractionLossAudioIn = `${get(newParty, "audio_in.fractionLoss")||0}% (${get(newParty, "audio_in.fractionLossPeak")||0}%)`
          let fractionLossAudioOut = `${get(newParty, "audio_out.fractionLoss")||0}% (${get(newParty, "audio_out.fractionLossPeak")||0}%)`
          let fractionLossContentIn = `${get(newParty, "content_in.fractionLoss")||0}% (${get(newParty, "content_in.fractionLossPeak")||0}%)`
          let fractionLossContentOut = `${get(newParty, "content_out.fractionLoss")||0}% (${get(newParty, "content_out.fractionLossPeak")||0}%)`
          return {
            partyId: get(newParty, "partyId"),
            name: get(newParty, "name"),
            time: moment(today).locale('en').format("MMMM Do YYYY, h:mm:ss a"),
            startTime: moment(get(newParty, "startTime")).add(7, 'hours').format("LTS"),
            endTime: get(newParty, "disconnectionCause") ? moment(get(newParty, "endTime")).add(7, 'hours').format("LTS") : moment(get(newParty, "endTime")).format("LTS"),
            disconnectionCause: get(newParty, "disconnectionCause"),
            biteRateVideoIn: get(newParty, "video_in.bitRate"),
            biteRateVideoOut: get(newParty, "video_out.bitRate"),
            biteRateAudioIn: get(newParty, "audio_in.bitRate"),
            biteRateAudioOut: get(newParty, "audio_out.bitRate"),
            biteRateContentIn: get(newParty, "content_in.bitRate"),
            biteRateContentOut: get(newParty, "content_out.bitRate"),
            packetLossVideoIn: get(newParty, "video_in.packetLoss"),
            packetLossVideoOut: get(newParty, "video_out.packetLoss"),
            packetLossAudioIn: get(newParty, "audio_in.packetLoss"),
            packetLossAudioOut: get(newParty, "audio_out.packetLoss"),
            packetLossContentIn: get(newParty, "content_in.packetLoss"),
            packetLossContentOut: get(newParty, "content_out.packetLoss"),
            fractionLossVideoIn,
            fractionLossVideoOut,
            fractionLossAudioIn,
            fractionLossAudioOut,
            fractionLossContentIn,
            fractionLossContentOut,
            jitterVideoIn: get(newParty, "video_in.jitter"),
            jitterVideoOut: get(newParty, "video_out.jitter"),
            jitterAudioIn: get(newParty, "audio_in.jitter"),
            jitterAudioOut: get(newParty, "audio_out.jitter"),
            jitterContentIn: get(newParty, "content_in.jitter"),
            jitterContentOut: get(newParty, "content_out.jitter")
          };
        });
    },
    alertPacket(party) {
      const { name, conferenceID } = party;
      this.getPartyPacket({
        name: name,
        conferenceId: conferenceID,
        roomId: this.roomId
      }).then(result => {
        if (result.data.status) {
          const item = result.data.message;
          this.$dialog.alert(`
          <h3 style="text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 10px">Packet Loss<h3>
          <table>
            <tr>
              <th></th>
              <th style="padding-left: 20px; padding-right: 20px">Packet Loss</th>
              <th style="padding-left: 20px; padding-right: 20px">Fraction Loss(Peak)</th>
            </tr>
            <tr>
              <th>Audio in</th>
              <td style="padding-left: 20px">${item.audio_in.packetLoss}</td>
              <td style="padding-left: 20px">${parseFloat(
                item.audio_in.fractionLoss
              ).toFixed(2)}(${parseFloat(
            item.audio_in.fractionLossPeak / 100
          ).toFixed(2)}%)</td>
            </tr>
            <tr>
              <th>Audio out</th>
              <td style="padding-left: 20px">${item.audio_out.packetLoss}</td>
              <td style="padding-left: 20px">${parseFloat(
                item.audio_out.fractionLoss
              ).toFixed(2)}(${parseFloat(
            item.audio_out.fractionLossPeak / 100
          ).toFixed(2)}%)</td>

            </tr>
            <tr>
              <th>Video in</th>
              <td style="padding-left: 20px">${item.video_in.packetLoss}</td>
              <td style="padding-left: 20px">${parseFloat(
                item.video_in.fractionLoss
              ).toFixed(2)}(${parseFloat(
            item.video_in.fractionLossPeak / 100
          ).toFixed(2)}%)</td>
            </tr>
            <tr>
              <th>Video out</th>
              <td style="padding-left: 20px">${item.video_out.packetLoss}</td>
              <td style="padding-left: 20px">${parseFloat(
                item.video_out.fractionLoss
              ).toFixed(2)}(${parseFloat(
            item.video_out.fractionLossPeak / 100
          ).toFixed(2)}%)</td>
            </tr>
          </table>
            
          `);
        }
      });
    },
    cancelBookedRoom() {
      this.isBookedRoomModalActive = false;
      const bookedPartiesConference = JSON.parse(
        localStorage.getItem("bookedParties")
      );
      if (bookedPartiesConference) {
        if (this.conferenceId !== bookedPartiesConference.conferenceId) {
          this.resetBookedParties();
        }
      } else {
        this.resetBookedParties();
      }
    },
    changeLayoutImage(layout, cell) {
      this.selectedLayoutParty = [];
      this.selectedLayout = layout;
      this.selectedCell = cell;
    },
    changePartyLayoutImage(layout) {
      this.selectedPartyLayoutList = {
        ...(this.selectedPartyLayoutList&&this.selectedPartyLayoutList),
        [this.rowPartyLayout.id]: layout
      }
    },
    createPasscode() {
      this.$validator.validateAll("passCodeForm").then(result => {
        if (result) {
          this.updateConferencePasswordMCU({
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU,
            confPassword: this.newPasscode
          }).then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Thay đổi mật khẩu thành công",
                type: "is-info"
              });
            } else {
              this.$toast.open({
                message: "Thay đổi mật khẩu không thành công",
                type: "is-danger"
              });
            }
          });

          this.newPasscode = 0;
          this.$nextTick(() => {
            this.$validator.reset();
            this.isOpenPassCodeModal = false;
          });
        }
      });
    },
    createDialOut() {
      this.$validator.validateAll("dialOut").then(result => {
        if (result) {
          Promise.all(
            this.handedDialOut.map(user => {
              return this.setDialOut({
                type: this.dialOut.type,
                name: user.firstName,
                text: user.email,
                conferenceId: this.conferenceId
              });
            })
          ).then(result => {
            if (result.every(item => item)) {
              this.$toast.open({
                message: "Gọi đến điểm cầu thành công",
                type: "is-info"
              });
            }
            this.isOpenDialModal = false;
          });
        }
      });
    },
    deletePasscode() {
      this.updateConferencePasswordMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        confPassword: ""
      }).then(res => {
        if (res.data.status) {
          this.$toast.open({
            message: "Xoá mật khẩu thành công",
            type: "is-info"
          });
        } else {
          this.$toast.open({
            message: "Xoá mật khẩu không thành công",
            type: "is-danger"
          });
        }
        this.isResetPassCodeModal = false;
      });
    },
    deletePartyMCUView() {
      if(!this.isDeletePartyMCUModal) return
      this.deletePartyMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        partyId: this.selectedParticipant.id
      })
      .then(res => {
        this.isDeletePartyMCUModal = false
        if(res.data.status) {
          this.$toast.open({
            message: 'Xoá điểm cầu thành công',
            type: "is-info"
          })
          this.selectedParticipant = null
        } else {
          this.$toast.open({
            message: 'Xoá điểm cầu không thành công',
            type: "is-info"
          })
        }
        this.getPartyListInterval()
      })
    },
    disconnect(ptcp) {
      this.selectedDisconnectParty = null;
      this.deleteParticipant(ptcp);
      this.isDisconnectModalActive = false;
    },
    disconnectAll() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.isAllDisconnectModalActive = false;
      this.disconnectAllParty({
        conferenceId: this.conferenceId,
        roomId: this.roomId,
        owner: this.$store.state.auth.username
      })
        .then(res => {
          if (res.data.status) {
            this.$toast.open({
              message: "Ngắt kết nối các điểm cầu thành công",
              type: "is-info"
            });
            this.$router.push("/ongoing-conference-list");
          } else {
            this.$toast.open({
              message: "Ngắt kết nối các điểm cầu thất bại",
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    dialOutByIPID() {
      this.$validator.validateAll("dialOutByIPID").then(result => {
        if (result) {
          this.setDialOutByIPID({
            party: {
              name: this.dialOut.name,
              dialType: this.dialOut.type,
              ip: this.dialOut.text,
              id: this.dialOut.id
            },
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          }).then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Gọi đến điểm cầu thành công",
                type: "is-info"
              });
            }
          }).finally(() => {
            this.dialOut.name = ""
            this.dialOut.text = "0.0.0.0";
            this.dialOut.type = "";
            this.$nextTick(() => {
              this.$validator.reset()
              this.isOpenDialModal = false;
            });
          });
        }
      });
    },
    enableExclusiveShareContent() {
      this.$validator.validateAll("shareContentForm").then(result => {
        if (result) {
          const selectedParticipant = this.selectedParticipant;
          this.isShareContentModalActive = false;
          if (!selectedParticipant) return;
          clearTimeout(this.partyIntervalId);
          if (this.isLoading) return;
          this.isLoading = true;
          this.setShareContentParticipant({
            party: selectedParticipant,
            list: this.jointParticipants,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU,
            conferenceId: this.conferenceId
          })
            .then(dataRes => {
              if (dataRes.status) {
                this.$toast.open({
                  message: "Chia sẻ màn hình thành công",
                  type: "is-info"
                });
              } else {
                this.$toast.open({
                  message: dataRes.message,
                  type: "is-danger"
                });
              }
            })
            .finally(() => {
              this.isLoading = false;
              this.getConfPartyByMCU({
                conferenceId: this.conferenceId,
                roomID_MCU: this.roomID_MCU,
                host_MCU: this.host_MCU
              });
              this.getPartyListInterval();
            });
        }
      });
    },
    filterConnect() {
      if (!this.selectedBookedParties) return
      this.isBookedRoomModalActive = false
      const bookedPartiesConference = {
        conferenceId: this.conferenceId,
        parties: this.selectedBookedParties
      }
      localStorage.setItem(
        "bookedParties",
        JSON.stringify(bookedPartiesConference)
      )
      this.refusedParties = this.jointParticipants.filter(user => {
        return this.selectedBookedParties.every(party => {
          return !user.name.includes(party);
        });
      })
      this.refusedParties.map(user => {
        this.disconnect(user);
      })

      clearTimeout(this.bookedIntervalId)
      this.bookedIntervalId = setInterval(() => {
        this.refusedParties = this.jointParticipants.filter(user => {
          return !this.selectedBookedParties.includes(user.name);
        });
        this.refusedParties.map(user => {
          this.disconnectPartyMCUView(user);
        });
      }, 5000)
    },
    getConferenceList() {
      return this.getRooms(this.$store.state.auth.username).then(() => {
        return this.getConferenceIdList({
          roomIds: this.roomList.map(room => room.roomIdentifier)
        })
        .then(res => {
          const conferenceList = this.conferenceIdentityList
          if (!conferenceList) {
            this.$router.push("/ongoing-conference-list")
          }
          if (conferenceList) {
            const roomOb = conferenceList.find(conference => {
              return conference.conferenceId === this.conferenceId
            })
            if (!roomOb && !roomOb.roomId) {
              this.$router.push("/ongoing-conference-list");
            }
            this.roomId = roomOb.roomId;
            this.isLocked = roomOb.locked === "false" ? false : true
          }
          return res;
        });
      });
    },
    handleShareContent() {
      this.isShareContentModalActive = true;
    },
    lockConferenceRoom() {
      if (this.isLoadingLocked) return;
      this.isLoadingLocked = true;
      this.lockConference({ conferenceId: this.conferenceId }).then(res => {
        this.getConferenceList().then(() => {
          this.isLocked = true;
          this.isLoadingLocked = false;
        });
        if (res.data.status) {
          this.$toast.open({
            message: "Đã khoá cuộc họp",
            type: "is-info"
          });
        }
      });
    },
    muteAllAudio() {
      clearTimeout(this.partyIntervalId);
      this.setLoopingTimeConference();
      this.muteAll({ conferenceId: this.conferenceId }).then(() => {
        this.$toast.open({
          message: "Tất cả mic của người dùng đã được tắt",
          type: "is-info"
        });
      });
    },
    unmuteAllAudio() {
      clearTimeout(this.partyIntervalId);
      this.setLoopingTimeConference();
      this.unmuteAll({ conferenceId: this.conferenceId }).then(() => {
        this.$toast.open({
          message: "Tất cả mic của người dùng đã được bật",
          type: "is-info"
        });
      });
    },
    updateSelectedParty(evt) {
      this.selectedParticipant = evt;
    },
    unLockConferenceRoom() {
      if (this.isLoadingLocked) return;
      this.isLoadingLocked = true;
      this.unLockConference({ conferenceId: this.conferenceId }).then(res => {
        this.getConferenceList().then(() => {
          this.isLocked = false;
          this.isLoadingLocked = false;
        });
        if (res.data.status) {
          this.$toast.open({
            message: "Đã mở khoá cuộc họp",
            type: "is-info"
          });
        }
      });
    },
    setLecturerChannel() {
      this.$validator.validateAll("setLecturer").then(result => {
        if (result) {
          this.isOpenLecturerModal = false;
          if (this.selectedLecturer) {
            this.setLecturer({
              lecturer: this.selectedLecturer.id,
              conferenceId: this.conferenceId
            }).then(res => {
              if (res.data.status) {
                this.$toast.open({
                  message: "Chọn người phát biểu thành công",
                  type: "is-info"
                });
              }
            });
          }
        }
      });
    },
    saveLayout() {
      this.setLayout({
        conferenceId: this.conferenceId,
        layout: this.selectedLayout
      })
        .then(res => {
          if (res.data.status) {
            this.isLayoutModalActive = false;
            this.$toast.open({
              message: "Layout đổi thành công",
              type: "is-info"
            });
          }
        })
        .catch(err => {
          console.info(err);
        });
    },
    setMuteSingleVideo(ptcp) {
      clearTimeout(this.partyIntervalId);
      this.setLoopingTimeConference();
      this.muteVideo(ptcp);
    },
    setLayoutByParty() {
      const selectedParticipant = this.rowPartyLayout;
      if (!selectedParticipant || !this.selectedPartyLayoutList[selectedParticipant.id].length) return;
      selectedParticipant.forcedLayout = this.selectedPartyLayoutList[selectedParticipant.id];
      if (this.isLoading) return;
      this.isLoading = true;

      this.setPartyLayout({
        party: selectedParticipant,
        layout: {
          layout: this.selectedPartyLayoutList[selectedParticipant.id],
          force: this.forcedLayoutParty[selectedParticipant.id]
        },
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      })
        .then(dataRes => {
          if (dataRes.status) {
            this.$toast.open({
              message: "Tạo layout cho điểm cầu thành công",
              type: "is-info"
            });
          } else {
            this.$toast.open({
              message: dataRes.message,
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isPartyLayoutModalActive = false;
        });
    },
    getRealtimeData() {
      const self = this;

      socket.on("updateHandupList", function(data) {
        const validatedData = data || [];

        self.realtimeHandup = validatedData.filter(
          subData => subData.room === self.$store.state.auth.entityTag
        );
      });

      socket.on("handupList", function(data) {
        const validatedData = data || [];
        self.realtimeHandup = validatedData.filter(
          subData => subData.room === self.$store.state.auth.entityTag
        );
      });

      socket.emit("subscribe", {
        room: self.$store.state.auth.entityTag,
        user: self.$store.state.auth.username
      });
    },
    updateKeyword(evt) {
      this.keywordPartyName = evt;
    },
    resetLayoutByParty() {
      const selectedParticipant = this.rowPartyLayout;
      this.isPartyLayoutModalActive = false;
      if (!selectedParticipant) return;
      selectedParticipant.forcedLayout = this.selectedPartyLayoutList[selectedParticipant.id];
      if (this.isLoading) return;
      this.isLoading = true;
      this.resetPartyLayout({
        party: selectedParticipant,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      })
        .then(dataRes => {
          if (dataRes.status) {
            this.$toast.open({
              message: "Đặt lại layout cho điểm cầu thành công",
              type: "is-info"
            });
            this.selectedPartyLayoutList[selectedParticipant.id] = null
            this.forcedLayoutParty[selectedParticipant.id] = null
          } else {
            this.$toast.open({
              message: dataRes.message,
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    selectBookedRoom(participants) {
      this.selectedBookedParties = participants;
    },
    resetBookedParties() {
      this.selectedBookedParties = null;
      localStorage.removeItem("bookedParties");
      clearInterval(this.bookedIntervalId);
    },
    initBookedParties() {
      const bookedPartiesConference = JSON.parse(
        localStorage.getItem("bookedParties")
      );
      if (bookedPartiesConference) {
        if (this.conferenceId === bookedPartiesConference.conferenceId) {
          this.selectedBookedParties = bookedPartiesConference.parties;
          this.filterConnect();
        } else {
          this.resetBookedParties();
        }
      }
    },
    getPartyListInterval() {
      this.getConfPartyByMCU({
        conferenceId: this.conferenceId,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        realtimeHandup: this.realtimeHandup
      }).finally(() => {
        if (!this.jointParticipants.length) {
          this.$router.push("/ongoing-conference-list");
        }
        clearTimeout(this.partyIntervalId);
        this.partyIntervalId = setTimeout(() => {
          this.getPartyListInterval();
        }, 5000);
      });
    },
    muteMediaPartyList(config) {
      if (
        !this.selectedMediaParticipantIDs ||
        !this.selectedMediaParticipantIDs.length
      ) {
        this.isMediaButtonClicked = true;
        return;
      }
      clearTimeout(this.partyIntervalId);
      this.setLoopingTimeConference();
      const list = this.filteredParticipants.filter(party => {
        return this.selectedMediaParticipantIDs.some(id => {
          return id === party.id;
        });
      });
      Promise.all(
        list.map(party => {
          if ("audioMute" in config) {
            return this.muteAudio({ ...party, ...config });
          }
          if ("videoMute" in config) {
            return this.muteVideo({ ...party, ...config });
          }
          return null;
        })
      ).finally(() => {
        this.isMediaButtonClicked = false;
      });
    },
    muteAudioPartyList() {
      this.muteMediaPartyList({ audioMute: "false" });
    },
    muteVideoPartyList() {
      this.muteMediaPartyList({ videoMute: "false" });
    },
    openDeletePartyModal(party) {
      this.selectedParticipant = party
      this.isDeletePartyMCUModal = true
    },
    openDisconnectModal(party) {
      this.selectedDisconnectParty = party;
      this.isDisconnectModalActive = true;
    },
    openUpdateDisplayNameModal(party) {
      this.selectedDisplayParty = party;
      this.isDisplayNameModalActive = true;
    },
    openModalLayoutByParty(data) {
      this.rowPartyLayout = data;
      this.isPartyLayoutModalActive = true;
    },
    resetLayout() {
      this.isLayoutModalActive = false;
      this.selectedLayout = 0;
      this.resetDefaultLayout({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      }).then(res => {
        if (res.data.status) {
          this.$toast.open({
            message: "Layout được đổi thành công",
            type: "is-info"
          });
        } else {
          this.$toast.open({
            message: res.data.message,
            type: "is-danger"
          });
        }
      });
    },
    resetShareContentParty() {
      if (this.isLoading) return;
      clearTimeout(this.partyIntervalId);
      this.selectedParticipant = null;
      this.isLoading = true;
      let newList = [...this.jointParticipants];
      newList = newList.map(party => {
        party.shareContent = true;
        return party;
      });
      this.resetShareContentByParticipant({
        list: newList,
        conferenceId: this.conferenceId,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      })
        .then(dataRes => {
          if (dataRes.status) {
            this.$toast.open({
              message: "Đặt lại chia sẻ màn hình thành công",
              type: "is-info"
            });
          } else {
            this.$toast.open({
              message: dataRes.message,
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isShareContentModalActive = false;
          this.getConfPartyByMCU({
            conferenceId: this.conferenceId,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
          this.getPartyListInterval();
        });
    },
    setLoopingTimeConference() {
      this.partyIntervalId = setInterval(() => {
        this.getJointParticipantsByConfId({
          conferenceId: this.conferenceId,
          roomId: this.roomId
        }).then(resData => {
          if (!this.jointParticipants.length || !resData.data.status) {
            this.$router.push("/ongoing-conference");
          }
        });
      }, 5000);
    },
    setMuteSingleAudio(ptcp) {
      clearTimeout(this.partyIntervalId);
      this.setLoopingTimeConference();
      this.muteAudio(ptcp);
    },
    sortByColumn(type) {
      this.sortableValue = this.sortableValue === "asc" ? "dsc" : "asc";
      this.sortData({ type: type, value: this.sortableValue });
    },
    unmuteAudioPartyList() {
      this.muteMediaPartyList({ audioMute: "true" });
    },
    unmuteVideoPartyList() {
      this.muteMediaPartyList({ videoMute: "true" });
    },
    updateDisplayName() {
      this.$validator.validateAll("formDisplayName").then(result => {
        if (result) {
          const data = {
            owner: this.$store.state.auth.username,
            roomId: this.roomId,
            conferenceId: this.conferenceId,
            participantId: this.selectedDisplayParty.id,
            newDisplayName: this.displayName.split(" ").join("_")
          };
          this.changeDisplayNameParty(data)
            .then(result => {
              if (result.status) {
                this.$toast.open({
                  message: "Cập nhật tên hiển thị thành công"
                });
              } else {
                this.$toast.open({
                  message: result.message
                });
              }
            })
            .finally(() => {
              this.selectedDisplayParty = null;
              this.displayName = "";
              this.$nextTick(() => {
                this.isDisplayNameModalActive = false;
              });
            });
        }
      });
    },
    unselectLecturer() {
      this.isOpenLecturerModal = false;
      if (this.selectedLecturer) {
        this.setLecturer({ lecturer: "", conferenceId: this.conferenceId })
          .then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Bỏ chọn người phát biểu thành công",
                type: "is-info"
              });
            }
          })
          .finally(() => {
            this.selectedLecturer = null;
          });
      }
    },
    updateDialParticipant(evt) {
      if (evt&&evt.length) {
        this.dialOut.name = evt[0].firstName;
        this.dialOut.text = evt[0].email;
      } else {
        this.dialOut.name = "";
        this.dialOut.text = "";
      }
    },
    terminateMCU() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.isRemoveConfModalActive = false;
      this.disconnectAllPartyMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        conferenceId: this.conferenceId,
        owner: this.$store.state.auth.username
      })
        .then(res => {
          if (res.data.status) {
            this.$toast.open({
              message: "Xoá cuộc họp thành công",
              type: "is-info"
            });
            this.$router.push("/ongoing-conference-list");
          } else {
            this.$toast.open({
              message: "Xoá cuộc họp thất bại",
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    disconnectAllActivePartyMCU() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.isAllDisconnectModalActive = false;
      Promise.all(
        this.filteredParticipants.map(party => {
          return this.disconnectPartyMCU({
            ...party,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
        })
      )
        .then(res => {
          if (res.every(resu => resu.data.status)) {
            this.$toast.open({
              message: "Ngắt kết nối các điểm cầu thành công",
              type: "is-info"
            });
          } else {
            this.$toast.open({
              message: "Ngắt kết nối các điểm cầu thất bại",
              type: "is-danger"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    disconnectPartyMCUView(ptcp) {
      clearTimeout(this.partyIntervalId);
      this.disconnectPartyMCU({
        ...ptcp,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      })
      .then(res => {
        if (res.data.status) {
          this.selectedDisconnectParty = null;
          this.partyIntervalId = setTimeout(() => {
            this.getConfPartyByMCU({
              conferenceId: this.conferenceId,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
          }, 500);
          this.isDisconnectModalActive = false;
          this.getPartyListInterval();
        }
      });
    },
    setMuteSingleAudioMCU(ptcp) {
      clearTimeout(this.partyIntervalId);
      this.muteAudioMCU({
        ...ptcp,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      }).then(res => {
        if (res.data.status) {
          this.getConfPartyByMCU({
            conferenceId: this.conferenceId,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
          this.getPartyListInterval();
        }
      });
    },
    setMuteSingleVideoMCU(ptcp) {
      clearTimeout(this.partyIntervalId);
      this.muteVideoMCU({
        ...ptcp,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      }).then(res => {
        if (res.data.status) {
          this.getConfPartyByMCU({
            conferenceId: this.conferenceId,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
          this.getPartyListInterval();
        }
      });
    },
    setMuteAllAudioMCU() {
      clearTimeout(this.partyIntervalId);
      this.muteAllMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      }).then(res => {
        if (res.data.status) {
          this.getConfPartyByMCU({
            conferenceId: this.conferenceId,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
          this.getPartyListInterval();
        }
      });
    },
    reloadPartyListMCU() {
      clearTimeout(this.partyIntervalId);
      this.getConfPartyByMCU({
        conferenceId: this.conferenceId,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      });
      this.getPartyListInterval();
    },
    saveLayoutMCU() {
      const newLayout = {
        layout: this.selectedLayout,
        numCell: this.selectedCell,
        force: this.selectedLayoutParty
      };
      this.setLayoutMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        layout: newLayout
      })
        .then(res => {
          if (res.data.status) {
            this.isLayoutModalActive = false;
            this.$toast.open({
              message: "Layout đổi thành công",
              type: "is-info"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    muteMediaPartyListMCU(config) {
      if (
        !this.selectedMediaParticipantIDs ||
        !this.selectedMediaParticipantIDs.length
      ) {
        this.isMediaButtonClicked = true;
        return;
      }
      clearTimeout(this.partyIntervalId);
      const list = this.filteredParticipants.filter(party => {
        return this.selectedMediaParticipantIDs.some(id => {
          return id === party.id;
        });
      });
      Promise.all(
        list.map(party => {
          if ("audioMute" in config) {
            return this.muteAudioMCU({
              ...party,
              ...config,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
          }
          if ("videoMute" in config) {
            return this.muteVideoMCU({
              ...party,
              ...config,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
          }
          if ("audioBlockStatus" in config) {
            return this.updateBlockAudioMCU({
              partyId: party.id,
              ...config,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
          }
          return null;
        })
      )
        .then(() => {
          this.getConfPartyByMCU({
            conferenceId: this.conferenceId,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU
          });
          this.getPartyListInterval();
        })
        .finally(() => {
          this.isMediaButtonClicked = false;
        });
    },
    muteAudioPartyListMCU() {
      this.muteMediaPartyListMCU({ audioMute: "false" });
    },
    muteVideoPartyListMCU() {
      this.muteMediaPartyListMCU({ videoMute: "false" });
    },
    muteAudioBlockPartyListMCU() {
      this.muteMediaPartyListMCU({ audioBlockStatus: "true" });
    },
    selectVolumeMCU(ptcp) {
      this.selectedParticipant = ptcp;
      this.selectedVolume = this.selectedParticipant.volume;
      this.isSetVolumeModal = true;
    },
    selectListenVolumeMCU(ptcp) {
      this.selectedParticipant = ptcp;
      this.selectedVolume = this.selectedParticipant.volume;
      this.isSetListenVolumeModal = true;
    },
    selectPackageMCU(ptcp) {
      this.selectedParticipant = ptcp;
      this.isOpenPackageModal = true;
    },
    setLecturerChannelMCU() {
      this.$validator.validateAll("setLecturer").then(result => {
        if (result) {
          this.isOpenLecturerModal = false;
          if (this.selectedLecturer) {
            this.setLecturerMCU({
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU,
              partyMCU_Name: this.selectedLecturer.MCU_Name,
              lecturerMode: "SET_LECTURER"
            }).then(res => {
              if (res.data.status) {
                this.$toast.open({
                  message: "Chọn người phát biểu thành công",
                  type: "is-info"
                });
              }
            });
          }
        }
      });
    },
    setselectedPartyLayoutList(newData) {
      if (newData && newData.id) {
        this.selectedLayoutParty = [
          ...(
            this.selectedLayoutParty.length <= 1 ? []: this.selectedLayoutParty.filter(party => {
              return party.id !== newData.id;
            })
          ),
          newData
        ];
      } else if (newData && !newData.id) {
        this.selectedLayoutParty = this.selectedLayoutParty.filter(party => {
          return party.cell !== newData.cell;
        });
      }
    },
    setForcedPartyLayout(newData) {
      const partyId = this.rowPartyLayout.id;
      if (newData && newData.id) {
        this.forcedLayoutParty = {
          ...(this.forcedLayoutParty && this.forcedLayoutParty),
          [partyId]: [
            ...((this.forcedLayoutParty &&
              this.forcedLayoutParty[partyId] &&(
                this.selectedPartyLayoutList[partyId] == '1x1' ? []:
                this.forcedLayoutParty[partyId].filter(party => {
                  return party.id !== newData.id;
                })
              )) || []),
            newData
          ]
        };
      } else if (newData && !newData.id) {
        this.forcedLayoutParty = {
          ...(this.forcedLayoutParty && this.forcedLayoutParty),
          [partyId]: [
            ...((this.forcedLayoutParty &&
              this.forcedLayoutParty[partyId] &&
              this.forcedLayoutParty[partyId].filter(party => {
                return party.cell !== newData.cell;
              })) ||
              [])
          ]
        };
      }
    },
    setAutoLayoutMCUView() {
      this.isLayoutModalActive = false;
      this.selectedLayout = 0;
      this.setAutoLayoutMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU
      }).then(res => {
        if (res.data.status) {
          this.$toast.open({
            message: "Layout được đổi thành công",
            type: "is-info"
          });
        } else {
          this.$toast.open({
            message: res.data.message,
            type: "is-danger"
          });
        }
      });
    },
    toggleBlockAudioMCU(ptcp) {
      clearTimeout(this.partyIntervalId);
      const audioBlockStatus = ptcp.audioBlock === "true" ? false : true;
      this.updateBlockAudioMCU({
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        partyId: ptcp.id,
        audioBlockStatus
      }).then(() => {
        this.getConfPartyByMCU({
          conferenceId: this.conferenceId,
          roomID_MCU: this.roomID_MCU,
          host_MCU: this.host_MCU
        });
        this.getPartyListInterval();
      });
    },
    updateVolumeMCU() {
      this.$validator.validateAll("volumeForm").then(result => {
        if (result) {
          clearTimeout(this.partyIntervalId);
          this.setVolumeMCU({
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU,
            partyId: this.selectedParticipant.id,
            volume: this.selectedVolume
          }).finally(() => {
            this.getConfPartyByMCU({
              conferenceId: this.conferenceId,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
            this.getPartyListInterval();
            this.isSetVolumeModal = false;
          });
        }
      });
    },
    updateListenVolumeMCU() {
      this.$validator.validateAll("listenVolumeForm").then(result => {
        if (result) {
          clearTimeout(this.partyIntervalId);
          this.setListenVolumeMCU({
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU,
            partyId: this.selectedParticipant.id,
            volume: this.selectedListenVolume
          }).finally(() => {
            this.getConfPartyByMCU({
              conferenceId: this.conferenceId,
              roomID_MCU: this.roomID_MCU,
              host_MCU: this.host_MCU
            });
            this.getPartyListInterval();
            this.isSetListenVolumeModal = false;
          });
        }
      });
    },
    updateDisplayNameMCU() {
      this.$validator.validateAll("formDisplayName").then(result => {
        if (result) {
          const data = {
            owner: this.$store.state.auth.username,
            roomID_MCU: this.roomID_MCU,
            host_MCU: this.host_MCU,
            participantId: this.selectedDisplayParty.id,
            newDisplayName: this.displayName
          };
          this.changeDisplayNamePartyMCU(data)
            .then(result => {
              this.reloadPartyListMCU();
              if (result.status) {
                this.$toast.open({
                  message: "Cập nhật tên hiển thị thành công"
                });
              } else {
                this.$toast.open({
                  message: result.message
                });
              }
            })
            .finally(() => {
              this.selectedDisplayParty = null;
              this.displayName = "";
              this.$nextTick(() => {
                this.isDisplayNameModalActive = false;
              });
            });
        }
      });
    },
    unselectLecturerMCU() {
      this.isOpenLecturerModal = false;
      if (this.selectedLecturer) {
        this.setLecturerMCU({
          roomID_MCU: this.roomID_MCU,
          host_MCU: this.host_MCU,
          lecturerMode: "REMOVE_LECTURER"
        })
          .then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Bỏ chọn người phát biểu thành công",
                type: "is-info"
              });
            }
          })
          .finally(() => {
            this.selectedLecturer = null;
          });
      }
    },
    unmuteAudioPartyListMCU() {
      this.muteMediaPartyListMCU({ audioMute: "true" });
    },
    unmuteVideoPartyListMCU() {
      this.muteMediaPartyListMCU({ videoMute: "true" });
    },

    setTimerText() {
      this.setCurrentConferenceIdForAddText({
        conferenceId: this.conferenceId,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        time: this.timeSelected
      }).then(result => {
        const stt = result.data.status;
        if (stt) {
          this.getCurrentConferenceIdForAddText({
            conferenceId: this.conferenceId
          }).then(res => {
            const data = res.data;
            if (data.status) {
              this.isTimer = data.timer;
            }
          });
        }
      });
    },

    removeTimerText() {
      this.setCurrentConferenceIdForAddText({
        conferenceId: this.conferenceId,
        roomID_MCU: this.roomID_MCU,
        host_MCU: this.host_MCU,
        time: -1
      }).then(result => {
        const stt = result.data.status;
        if (stt) {
          this.getCurrentConferenceIdForAddText({
            conferenceId: this.conferenceId
          }).then(res => {
            const data = res.data;
            if (data.status) {
              this.isTimer = data.timer;
            }
          });
        }
      });
    },

    unmuteAudioBlockPartyListMCU() {
      this.muteMediaPartyListMCU({ audioBlockStatus: "false" });
    }
  },
  computed: {
    ...mapState("room", [
      "jointParticipants",
      "conferenceIdentityList",
      "roomList",
      "bookedRoomList",
      "sortPartySetting"
    ]),
    ...mapState("participant", ["userListByAdmin"]),
    filterDeviceList() {
      const filterUser = this.participants.filter(user => {
        return this.filteredParticipants.every(party => {
          return party.name&&!party.name.includes(user.firstName);
        });
      });
      const filterUserByAdmin =
        (this.userListByAdmin &&
          this.userListByAdmin.filter(user => {
            return this.filteredParticipants.every(party => {
              return !party.name.includes(user.firstName);
            });
          })) ||
        [];
      return [...filterUser, ...filterUserByAdmin].sort((party1, party2) => {
        return party1.firstName.localeCompare(String(party2.firstName), 'en', {numeric: true})
      })
    },
    filteredParticipants() {
      const partyLayoutContentList = JSON.parse(
        localStorage.getItem("partyLayoutJointParticipants")
      );

      const hasPartyLayoutContentList = () => {
        if (partyLayoutContentList) {
          if (this.conferenceId !== partyLayoutContentList.conferenceId) {
            localStorage.removeItem("partyLayoutJointParticipants");
            return false;
          }
          return true;
        }
        return false;
      };
      if (this.keywordPartyName.length) {
        return this.jointParticipants.filter(participant => {
          const newParty = { ...participant };
          if (hasPartyLayoutContentList()) {
            const person = partyLayoutContentList.participants.find(person => {
              return person.endpointName === newParty.endpointName;
            });
            if (person) {
              newParty.forcedLayout = person.forcedLayout;
            } else {
              newParty.forcedLayout = "";
            }
          }

          const name = newParty.name&&Utils.latinify(newParty.name);
          const keywordPartyName = Utils.latinify(this.keywordPartyName);
          return name.toLowerCase().includes(keywordPartyName.toLowerCase());
        });
      }

      return this.jointParticipants.map(participant => {
        const newParty = { ...participant };

        if (hasPartyLayoutContentList()) {
          const person = partyLayoutContentList.participants.find(person => {
            return person.endpointName === participant.endpointName;
          });
          if (person) {
            newParty.forcedLayout = person.forcedLayout;
          } else {
            newParty.forcedLayout = "";
          }
        }
        return newParty;
      });
    },
    isAllMutedAudio() {
      return this.jointParticipants.every(party => party.audioMute === "true");
    },
    isAllMutedVideo() {
      return this.jointParticipants.every(party => party.videoMute === "true");
    },
    shareContentParty() {
      return this.jointParticipants.find(party => party.shareContentStatus);
    },
    totalReport() {
      return [
        'Phòng họp',
        this.jointParticipants&&this.jointParticipants[0]&&this.jointParticipants[0].displayName,
        `Số điểm cầu đang kết nối`,
        this.totalConnect,
        `Tổng số lượt điểm cầu bị mất kết nối`,
        this.totalDisconnect
      ];
    },
    orderedParties() {
      const list = [...this.filteredParticipants]
      return list.sort((party1, party2) => {
        return String(party1.name).localeCompare(String(party2.name), 'en', {numeric: true})
      })
    }
  },
  filters: {
    shortenConferenceId(value) {
      return `Cuộc họp ${value.split("-")[0] + "..."}`;
    }
  },
  watch: {
    selectedAllMediaParticipantIDs() {
      this.selectedMediaParticipantIDs = [];
      if (this.selectedAllMediaParticipantIDs) {
        this.selectedMediaParticipantIDs = [
          ...this.filteredParticipants.map(party => party.id)
        ];
      }
    },
    checkboxDialOutIPID(value) {
      if(value) {
        this.dialOut.text='0.0.0.0'
      } else {
        this.dialOut.text=''
      }
    }
  },
  props: {
    headerConf: {
      type: Array,
      default: () => [
        {
          class: "sortable",
          sortColumnName: "audioMuteEndpoint",
          label: "Mic người dùng"
        },
        {
          class: "sortable",
          sortColumnName: "audioMute",
          label: "Mic quản trị"
        },
        {
          class: "sortable",
          sortColumnName: "audioBlock",
          label: "Block audio"
        },
        {
          class: "sortable conference-volume-setting-column",
          sortColumnName: "volume",
          label: "Tăng/Giảm âm lượng nói"
        },
        {
          class: "sortable conference-volume-setting-column",
          sortColumnName: "listenVolume",
          label: "Tăng/Giảm âm lượng nghe"
        },
        {
          class: "sortable",
          sortColumnName: "videoMute",
          label: "Video"
        },
        {
          class: "sortable",
          sortColumnName: "speaker",
          label: "Điểm đang nói"
        },
        {
          class: "sortable",
          sortColumnName: "lecturer",
          label: "Chủ trì"
        },
        {
          class: undefined,
          sortColumnName: undefined,
          label: "Layout"
        },
        {
          class: "sortable",
          sortColumnName: "isExclusiveContent",
          label: "Content"
        },
        {
          class: "sortable",
          sortColumnName: "shareContent",
          label: "Chia sẻ content"
        },
        {
          class: "sortable",
          sortColumnName: "isHandup",
          label: "Xin phát biểu"
        },
        {
          class: "sortable",
          sortColumnName: "signalingProtocol",
          label: "Phương thức"
        },
        // {
        //   class: "sortable",
        //   sortColumnName: "video_in",
        //   label: "Video in"
        // },
        // {
        //   class: "sortable",
        //   sortColumnName: "video_out",
        //   label: "Video out"
        // },
        // {
        //   class: "sortable",
        //   sortColumnName: "audio_in",
        //   label: "Audio in"
        // },
        // {
        //   class: "sortable",
        //   sortColumnName: "audio_out",
        //   label: "Audio out"
        // },
        // {
        //   class: "sortable",
        //   sortColumnName: "content_in",
        //   label: "Content in"
        // },
        // {
        //   class: "sortable",
        //   sortColumnName: "content_out",
        //   label: "Content out"
        // }
      ]
    },
    tableLossPackage: {
      type: Array,
      default: () => [
        {
          label: 'No',
          field: 'index',
          value: (obj) => obj.index
        },
        {
        label:'Name',
        field: 'name',
        value: (obj) => obj.name
      },
      {
        label:'Bite rate video in',
        field: 'video_in.bitRate',
        value: (obj) => obj.video_in.bitRate
      },
      {
        label: 'Bite rate video out',
        field: 'video_out.bitRate',
        value: (obj) => obj.video_out.bitRate
      },
      {
        label: 'Bite rate audio in',
        field: 'audio_in.bitRate',
        value: (obj) => obj.audio_in.bitRate
      },
      {
        label: 'Bite rate audio out',
        field: 'audio_out.bitRate',
        value: (obj) => obj.audio_out.bitRate
      },
      {
        label: 'Bite rate content in',
        field: 'content_in.bitRate',
        value: (obj) => obj.content_in.bitRate
      },
      {
        label: 'Bite rate content out',
        field: 'content_out.bitRate',
        value: (obj) => obj.content_out.bitRate
      },
      {
        label: 'Packet loss video in',
        field: 'video_in.packetLoss',
        value: (obj) => obj.video_in.packetLoss
      },
      {
        label: 'Packet loss video out',
        field: 'video_out.packetLoss',
        value: (obj) => obj.video_out.packetLoss
      },
      {
        label: 'Packet loss audio in',
        field: 'audio_in.packetLoss',
        value: (obj) => obj.audio_in.packetLoss
      },
      {
        label: 'Packet loss audio out',
        field: 'audio_out.packetLoss',
        value: (obj) => obj.audio_out.packetLoss
      },
      {
        label: 'Packet loss content in',
        field: 'content_in.packetLoss',
        value: (obj) => obj.content_in.packetLoss
      },
      {
        label:  'Packet loss content out',
        field: 'content_out.packetLoss',
        value: (obj) => obj.content_out.packetLoss
      },
      {
        label: 'Fraction loss video in (Peak)',
        field: 'video_in.fractionLoss',
        value: (obj) => obj.video_in.fractionLoss,
        valuePeak: (obj) => obj.video_in.fractionLossPeak
      },
      {
        label: 'Fraction loss video out (Peak)',
        field: 'video_out.fractionLoss',
        value: (obj) => obj.video_out.fractionLoss,
        valuePeak: (obj) => obj.video_out.fractionLossPeak
      },
      {
        label: 'Fraction loss audio in (Peak)',
        field: 'audio_in.fractionLoss',
        value: (obj) => obj.audio_in.fractionLoss,
        valuePeak: (obj) => obj.audio_in.fractionLossPeak
      },
      {
        label: 'Fraction loss audio out (Peak)',
        field: 'audio_out.fractionLoss',
        value: (obj) => obj.audio_out.fractionLoss,
        valuePeak: (obj) => obj.audio_out.fractionLossPeak
      },
      {
        label: 'Fraction loss content in (Peak)',
        field: 'content_in.fractionLoss',
        value: (obj) => obj.content_in.fractionLoss,
        valuePeak: (obj) => obj.content_in.fractionLossPeak
      },
      {
        label: 'Fraction loss content out (Peak)',
        field: 'content_out.fractionLoss',
        value: (obj) => obj.content_out.fractionLoss,
        valuePeak: (obj) => obj.content_out.fractionLossPeak
      },
      {
        label: 'Jitter video in',
        field: 'video_in.jitter',
        value: (obj) => obj.video_in.jitter
      },
      {
        label: 'Jitter video out',
        field: 'video_out.jitter',
        value: (obj) => obj.video_out.jitter
      },
      {
        label: 'Jitter audio in',
        field: 'audio_in.jitter',
        value: (obj) => obj.audio_in.jitter
      },
      {
        label: 'Jitter audio out',
        field: 'audio_out.jitter',
        value: (obj) => obj.audio_out.jitter
      },
      {
        label: 'Jitter content in',
        field: 'content_in.jitter',
        value: (obj) => obj.content_in.jitter
      },
      {
        label:  'Jitter content out',
        field: 'content_out.jitter',
        value: (obj) => obj.content_out.jitter
      },]
    }
  }
};
</script>


<style lang="scss" scope>
@import "vue-select/src/scss/vue-select.scss";
@import "@/assets/scss/partials/_colors.scss";
@import "@/assets/scss/form.scss";
.booked-room__conference-title {
  margin-bottom: 15px;
}
.button-delete-booked-parties {
  border-radius: 100%;
}
.button-update-name {
  cursor: pointer;
  background: #51b066;
  color: #fff;
  border-color: transparent;
  transition: all 0.5s;
  border-radius: 4px;
  &:hover {
    background-color: #106835;
  }
}
.button-setting-conf.is-info {
  background: #51b066;
}
.conference-arrow {
  display: inline-block;
  vertical-align: middle;
  svg {
    width: 15px;
    height: 15px;
  }
}
.conference-content {
  color: #363636;

  .table {
    border-spacing: 0;
    border-collapse: collapse;
    td {
      border: 1px solid #dbdbdb;
      vertical-align: middle;
      padding-top: 5px;
      padding-right: 0;
      padding-bottom: 5px;
      padding-left: 0;
      width: 50px;
      &.column__username {
        width: 200px;
      }
    }

    .table-header td {
      font-size: 12px;
      position: sticky;
      top: 0px;
      background: white;
      z-index: 1;
    }

    .column__control-single {
      width: 70px;
      padding-right: 0;
      padding-left: 0;
    }
    .column__control-signal {
      width: 110px;
      padding-right: 0;
      padding-left: 0;
    }
    .conference-checkbox-column {
      padding-left: 5px;
      width: 40px;
    }
    .conference-order-column {
      width: 40px;
    }
    .conference-volume-setting-column {
      width: 60px;
    }
  }
}
.conference-heading {
  background: $green;
  padding: 10px 15px;
  color: $white;
  font-size: 16px;
  position: relative;
  user-select: none;
}
.column__username {
  font-size: 14px;
}
.content-management {
  position: relative;
}
.conference-control {
  padding-top: 5px;
  padding-bottom: 5px;
  box-shadow: 0 0 20px 0 #ddd;

  &__row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
  }

  &__column {
    margin-left: 10px;
  }

  &__photo {
    cursor: pointer;
    img {
      width: 25px;
    }
  }

  &__name {
    font-size: 13px;
    &--small {
      width: 120px;
    }
  }

  &__label {
    font-weight: bold;
  }
}
.collapse-party {
  margin-top: 15px;
  flex: 1 0 auto;
}
.cover {
  width: 100%;
  height: 100%;
  position: relative;
}
.content-management-conference {
  display: flex;
  flex-direction: column;
}
.content-management-conference__label {
  flex-basis: auto;
}
.conference-content__wrapper {
  max-height: 500px;
  overflow-y: auto;
  .table {
    table-layout: fixed;
  }
}
.conference-table-text {
  // width: 150px;
  display: block;
}
.conference-media-error {
  padding-top: 5px;
}
.conference-table-select-all {
  font-size: 14px;
}
.conf-typo {
  margin-left: 10px;
}
.dsc {
  transform: rotateZ(180deg);
}
.icon-audio {
  background: url(../assets/images/icons/icon-audio.png) no-repeat left top;
  background-size: contain;
  height: 26px;
}
.icon-conf {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  width: 25px;
  margin-left: 5px;

  &--no-hand {
    cursor: default;
  }

  &--volume {
    width: 50px;
  }
}
.icon-disable-audio {
  background: url(../assets/images/icons/icon-disable_audio.png) no-repeat left
    top;
  background-size: contain;
  height: 26px;
}
.icon-disable-video {
  background: url(../assets/images/icons/icon-disable_camera.png) no-repeat left
    top;
  height: 26px;
  background-size: contain;
}
.icon-user {
  width: auto;
  margin-right: 25px;
  vertical-align: middle;

  svg.svg-inline--fa {
    width: 30px;
    height: 30px;
  }
}
.icon-video {
  background: url(../assets/images/icons/icon-camera.png) no-repeat left top;
  background-size: contain;
  height: 26px;
}
.icon-share-content {
  background: url(../assets/images/icons/icon-share_content.png) no-repeat left
    top;
  background-size: contain;
  height: 26px;
}
.icon-conf-other {
  vertical-align: middle;
  display: inline-block;
}
.icon-speaker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: block;
}
.icon-conf--speaker {
  margin-right: 15px;
}
.field-search-party {
  .input {
    height: 32px;
    width: 270px;
  }
}
.package-modal {
  .content-layout__inner {
    overflow: auto;
  }
}
.sidebar-menu__img {
  min-width: 41px;
}
.speaker {
  width: 0;
  height: 0;
  background: none;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 15px solid #51b066;

  &:before {
    content: "";
    position: absolute;
    top: -5px;
    left: 0;
    width: 19px;
    height: 10px;
    background: #51b066;
    border-radius: 3px 1.5em 1.5em 3px;
  }

  &:after {
    content: "";
    position: absolute;
    border-right: 3px solid #51b066;
    border-radius: 50%;
    animation: pump 0.2s 0.1s infinite alternate;
  }
}
.sortable {
  cursor: pointer;
}
.sort-icon {
  cursor: pointer;
  vertical-align: middle;
}
.table-package {
  font-size: 12px;
}
.b-table .table th.is-current-sort,
.b-table .table th.is-sortable:hover {
  border-color: #dbdbdb;
}
.table-all-loss-package {
  thead th {
    padding: 0;
    border-left: 1px solid #dbdbdb;
  }
  td {
    border-left: 1px solid #dbdbdb;
  }
}
.v-select {
  &.share-content-controller {
    width: auto;
    min-width: 125px;
  }
}
.volume-text {
  vertical-align: middle;
}
.volume-icon {
  vertical-align: middle;
}
.main {
  overflow-x: auto;
  overflow-y: hidden;
}
.modal--layout {
  .content-layout {
    max-width: 690px;
  }
}
.hero-body {
  padding-top: 6rem;
  padding-bottom: 4rem;
}
.container_layout {
  display: grid;
  max-width: 600px;
  width: 100%;
  height: 100%;
  min-height: 400px;
}
.sub-h {
  font-size: 17px;
  margin-top: 20px;
}
h3 {
  font-size: 20px;
}

._1x2 {
  .cell1 {
    grid-column: 1;
    grid-row: 1;
  }
  .cell2 {
    grid-column: 2;
    grid-row: 1;
  }
}

._3and1Vert {
  .cell1 {
    grid-column: 1;
    grid-row: 1 / span 3;
  }
  .cell2 {
    grid-column: 2;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 2;
    grid-row: 2;
  }
  .cell4 {
    grid-column: 2;
    grid-row: 3;
  }
}
._2x2 {
  .cell1 {
    grid-column: 1;
    grid-row: 1;
  }
  .cell2 {
    grid-column: 2;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 1;
    grid-row: 2;
  }
  .cell4 {
    grid-column: 2;
    grid-row: 2;
  }
}
._5and1 {
  .cell1 {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }
  .cell2 {
    grid-column: 3;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 3;
    grid-row: 2;
  }
  .cell4 {
    grid-column: 1;
    grid-row: 3;
  }
  .cell5 {
    grid-column: 2;
    grid-row: 3;
  }
  .cell6 {
    grid-column: 3;
    grid-row: 3;
  }
}

._7and1 {
  .cell1 {
    grid-column: 1 / span 3;
    grid-row: 1 / span 3;
  }
  .cell2 {
    grid-column: 4;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 4;
    grid-row: 2;
  }
  .cell4 {
    grid-column: 4;
    grid-row: 3;
  }
  .cell5 {
    grid-column: 1;
    grid-row: 4;
  }
  .cell6 {
    grid-column: 2;
    grid-row: 4;
  }
  .cell7 {
    grid-column: 3;
    grid-row: 4;
  }
  .cell8 {
    grid-column: 4;
    grid-row: 4;
  }
}

._3x3 {
  @for $i from 0 through 2 {
    @for $j from 0 through 2 {
      .cell#{$i * 3 + 1 + $j} {
        grid-column: #{$j + 1};
        grid-row: #{$i + 1};
      }
    }
  }
}

._8and2 {
  .cell1 {
    grid-column: 1;
    grid-row: 1;
  }
  .cell2 {
    grid-column: 2;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 3;
    grid-row: 1;
  }
  .cell4 {
    grid-column: 4;
    grid-row: 1;
  }
  .cell5 {
    grid-column: 1 / span 2;
    grid-row: 2 / span 2;
  }
  .cell6 {
    grid-column: 3 / span 2;
    grid-row: 2 / span 2;
  }
  .cell7 {
    grid-column: 1;
    grid-row: 4;
  }
  .cell8 {
    grid-column: 2;
    grid-row: 4;
  }
  .cell9 {
    grid-column: 3;
    grid-row: 4;
  }
  .cell10 {
    grid-column: 4;
    grid-row: 4;
  }
}

._12and1 {
  .cell1 {
    grid-column: 1;
    grid-row: 1;
  }
  .cell2 {
    grid-column: 2;
    grid-row: 1;
  }
  .cell3 {
    grid-column: 3;
    grid-row: 1;
  }
  .cell4 {
    grid-column: 4;
    grid-row: 1;
  }
  .cell5 {
    grid-column: 1;
    grid-row: 2;
  }
  .cell6 {
    grid-column: 2 / span 2;
    grid-row: 2 / span 2;
  }
  .cell7 {
    grid-column: 4;
    grid-row: 2;
  }
  .cell8 {
    grid-column: 1;
    grid-row: 3;
  }
  .cell9 {
    grid-column: 4;
    grid-row: 3;
  }
  .cell10 {
    grid-column: 1;
    grid-row: 4;
  }
  .cell11 {
    grid-column: 2;
    grid-row: 4;
  }
  .cell12 {
    grid-column: 3;
    grid-row: 4;
  }
  .cell13 {
    grid-column: 4;
    grid-row: 4;
  }
}

._4x4 {
  @for $i from 0 through 3 {
    @for $j from 0 through 3 {
      .cell#{$i * 4 + 1 + $j} {
        grid-column: #{$j + 1};
        grid-row: #{$i + 1};
      }
    }
  }
}

._4x5 {
  @for $i from 0 through 3 {
    @for $j from 1 through 5 {
      .cell#{$i * 5 + $j} {
        grid-column: #{$j + 1};
        grid-row: #{$i + 1};
      }
    }
  }
}
.cell {
  background: #fff;
  border: 2px solid #ccc;
  text-align: center;
  padding: 20px;
  font-size: 12px;
}
@keyframes pump {
  from {
    top: -7px;
    right: -26px;
    width: 12px;
    height: 12px;
  }
  to {
    top: -5px;
    right: -34px;
    width: 10px;
    height: 10px;
  }
}
.booked-room__conference,
.conference__endpoint-count {
  padding: 0 20px;
}

.conference__addText {
  padding: 10px 20px;
  .control {
    display: inline-block;
    margin-left: 5px;
    padding-right: 5px;
  }
}
</style>
